import { EnumBenefitInsurancePlanState } from "constants/enums/benefit-insurance-plan-state";
import { NameChangeRequestStatus } from "constants/enums/name-change-request-status";
import { NotificationTemplateType } from "constants/enums/notification-template-type";
import { EnumOrderStatus } from "constants/enums/order-status";
import { PaymentCategoryEnum } from "constants/enums/payment-category";
import { EnumPaymentMethod } from "constants/enums/payment-method";
import { EnumPaymentScheduleMethod } from "constants/enums/payment-schedule-method";
import { EnumPaymentStatus } from "constants/enums/payment-status";
import { PaymentTransactionStatusEnum } from "constants/enums/payment-transaction-status";
import { EnumRelationship } from "constants/enums/relationship";
const th = {
  translation: {
    common: {
      error: "เกิดข้อผิดพลาด",
    },
    client: {
      enhancers: {
        withPreventLeaveDirtyForm: {
          cancelEdit: "ยืนยันการออกจากหน้านี้",
          cancelConfirm:
            "การเปลี่ยนแปลงที่คุณทำจะไม่ถูกบันทึก คุณต้องการออกหรือไม่?",
          close: "กลับไปแก้ไข",
          canceledEdit: "ออกโดยไม่บันทึก",
        },
      },
      benefitInsurancePlanState: {
        draft: "ไม่สำเร็จ",
        [EnumBenefitInsurancePlanState.ACTIVE]: "มีผลบังคับ",
        [EnumBenefitInsurancePlanState.PENDING_REVIEW]: "กำลังรอพิจารณา",
        [EnumBenefitInsurancePlanState.REJECTED]: "ไม่ผ่านการพิจารณา",
        [EnumBenefitInsurancePlanState.CANCELING_REVIEW]: "อยู่ระหว่างยกเลิก",
        [EnumBenefitInsurancePlanState.REFUNDED]: "ยกเลิกและคืนเงินสำเร็จ",
        [EnumBenefitInsurancePlanState.INACTIVE]: "ไม่มีผลบังคับ",
        [EnumBenefitInsurancePlanState.PENDING_RENEWAL]: "กรมธรรม์ปีต่อ",
        [EnumBenefitInsurancePlanState.WAITING]: "กรุณาชำระเบี้ย",
        [EnumBenefitInsurancePlanState.CANCELED]: "ถูกยกเลิก",
        [EnumBenefitInsurancePlanState.OVER_DUE]: "เกินกำหนดชำระ",
        // [EnumBenefitInsurancePlanState.FAILED]: "ไม่สำเร็จ",
      },
      api: {
        modal401Title: "การเข้าสู่ระบบหมดอายุ",
        modal401Children:
          "การเข้าสู่ระบบหมดอายุ กรุณาทำการเข้าสู่ระบบใหม่อีกครั้ง",
        modal401OkButtonLabel: "เข้าสู่ระบบ",
        modal403Title: "เกิดข้อผิดพลาด",
        modal403Children:
          "บทบาทผู้ใช้งานของคุณไม่มีสิทธิ์ใช้งานส่วนนี้ กรุณาเข้าสู่ระบบอีกครั้ง",
        modal403OkButtonLabel: "เข้าสู่ระบบ",
        modal500Title: "เกิดข้อผิดพลาด",
        modal500OkButtonLabel: "ตกลง",
      },
      pages: {
        main: {
          admins: {
            index: {
              title: "เพิ่ม/ลด Admin",
              home: "หน้าแรก",
              addButton: "เพิ่มผู้ดูแลระบบ",
              admins: "เพิ่ม/ลด Admin",
              deleteButton: "ต้องการลบข้อมูลผู้ดูแลระบบ",
              columns: {
                fullName: "ชื่อ นามสกุล",
                email: "อีเมล",
                status: "สถานะ",
                code: "รหัส",
                lastActiveAt: "ใช้งานล่าสุด",
                createdAt: "สร้างเมื่อ",
                updatedAt: "แก้ไขล่าสุด",
                role: "บทบาท",
                values: {
                  availableStatus: {
                    active: "ใช้งาน",
                    inactive: "ไม่ใช้งาน",
                  },
                },
              },
            },
            new: {
              home: "หน้าแรก",
              rootPath: "ผู้ดูแลระบบ",
              title: "เพิ่มผู้ดูแลระบบ",
              header: "กรอกอีเมลผู้ดูแลระบบเพื่อส่งลิงก์เข้าใช้งาน",
              link: "ลิงก์เพื่อเข้าใช้งานระบบจะถูกส่งไปที่อีเมลนี้",
              send: "ส่งเมล",
              cancel: "ยกเลิก",
              email: "อีเมล",
              role: "บทบาท",
              notificationSuccess: "ทำรายการสำเร็จ",
            },
            edit: {
              title: "ข้อมูลทั่วไป",
              home: "หน้าแรก",
              rootPath: "ผู้ดูแลระบบ",
              status: "สถานะ",
              cancel: "ยกเลิก",
              save: "บันทึก",
              cantEditYourself:
                "การแก้ไขสถานะและบทบาทไม่สามารถทำได้ด้วยตัวเอง ต้องให้ Admin ที่มี permission แก้ไข permission ของ Admin ทำให้เท่านั้น เช่น Super Admin",
              firstName: "ชื่อ",
              lastName: "นามสกุล",
              role: "บทบาท",
              email: "อีเมล",
              available: "ใช้งานระบบ",
            },
          },
          frontStoreManagement: {
            index: {
              title: "จัดการ Front store",
              home: "หน้าแรก",
              addButton: "สร้าง Front store",
              DYNAMIC_CONFIG: "จัดการธีม",
              PACKAGE_DISPLAY: "ตั้งค่าแพ็กเกจประกัน",
              FATCA_QUESTIONS: "คำถาม FATCA",
              FRONT_STORE_APPEARANCE: "รายละเอียด Front store",
              tabsTitle: "รายละเอียด",
              filters: {
                title: "Front store",
                name: "ชื่อ Front store",
                type: "ประเภท",
                typeAll: "ทั้งหมด",
                typeFreelance: "freelance",
                typeEnterprise: "enterprise",
                reset: "รีเซ็ต",
                filter: "กรอง",
              },
              columns: {
                name: "ชื่อ Front store",
                type: "ประเภท",
                description: "หมายเหตุ",
                updatedAt: "วันเวลาที่แก้ไขล่าสุด",
              },
              deleteFrontStore: "ลบ Front Store",
              frontStoreInfo: "ข้อมูล Front Store",
              cannotBeRestored: "จะถูกลบและไม่สามารถกู้คืนได้",
              close: "ปิดหน้าต่างนี้",
              delete: "ลบข้อมูล",
              notificationSuccess: "ทำรายการสำเร็จ",
            },
            createModal: {
              title: "สร้าง Front store",
              name: "ชื่อ Front store",
              type: "ประเภท",
              typePlaceholder: "เลือกประเภท",
              typeFreelance: "freelance",
              typeEnterprise: "enterprise",
              cancel: "ยกเลิก",
              confirm: "ยืนยัน",
              success: "ทำรายการสำเร็จ",
              errorTitle: "เกิดข้อผิดพลาด",
              errorMessage: "ไม่สามารถสร้าง Front store ได้",
              errorClose: "ปิด",
            },
            details: {
              title: "รายละเอียด",
              name: "ชื่อ Front store",
              type: "ประเภท",
              description: "หมายเหตุ",
              cancel: "ยกเลิก",
              save: "บันทึก",
              success: "บันทึกสำเร็จ",
              typeFreelance: "freelance",
              typeEnterprise: "enterprise",
            },
            packageDisplay: {
              title: "ตั้งค่าแพ็กเกจประกัน",
              cantEditYourself:
                "เลือกแพ็กเกจประกันเพื่อแสดงใน “แพ็กเกจโปรโมชัน” และ “แพ็กเกจประกันยอดนิยมสำหรับคุณ” ของ Web Application ได้ที่ขั้นตอนนี้",
              enrollmentId: "รอบการลงทะเบียน",
              enrollmentIdHelperText:
                "เลือกรอบการลงทะเบียนที่สัมพันธ์กับ Application เพื่อจัดการแพ็กเกจที่ต้องการ",
              changeEnrollmentConfirmTitle: "ยืนยันการเปลี่ยนรอบการลงทะเบียน",
              changeEnrollmentConfirmMessage:
                "การเปลี่ยนรอบการลงทะเบียนจะลบแพ็กเกจโปรโมชันและแพ็กเกจยอดนิยมที่เลือกไว้ทั้งหมด ต้องการดำเนินการต่อหรือไม่?",
              changeEnrollmentConfirmCancel: "ยกเลิก",
              changeEnrollmentConfirmOk: "ยืนยัน",
              option1: "ตัวเลือก 1",
              promotionPackages: "แพ็กเกจโปรโมชัน",
              promotionPackagesDescription:
                'เลือกแพ็กเกจประกันเพื่อแสดงใน "แพ็กเกจโปรโมชัน" ของ Web Application (ลำดับการแสดงผลจะเรียงจากรายการบนลงล่างสุด)',
              recommendPackagesDescription:
                "เลือกแพ็กเกจประกันเพื่อแสดงใน “แพ็กเกจประกันยอดนิยมสำหรับคุณ” ของ Web Application \n (ลำดับการแสดงผลจะเริ่มจากรายการบนสุดไปล่างสุด)",
              recommendPackages: "แพ็กเกจยอดนิยมสำหรับคุณ",
              add: "เพิ่ม",
              image: "รูปภาพ",
              description: "รายละเอียด",
              actions: "จัดการ",
              name: "ชื่อ",
              save: "บันทึก",
              deleteModalTitle: "ลบแพ็กเกจ",
              deleteModalContent:
                "ข้อมูลแพ็กเกจ <b>{{name}}</b> จะถูกลบและไม่สามารถกู้คืนได้",
              close: "ปิดหน้าต่างนี้",
              delete: "ลบข้อมูล",
              components: {
                editPromotionPackageModal: {
                  save: "บันทึก",
                  cancel: "ยกเลิก",
                  image: "รูปประกอบ",
                  imageHelperText:
                    "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 190 x 143 pixel)",
                  description: "คำอธิบาย",
                  packageHeader: "แก้ไขข้อมูล {{name}}",
                },
              },
              success: "ทำรายการสำเร็จ",
            },
            fatcaQuestions: {
              fatcaDetails: "รายละเอียด FATCA",
              fatcaDetailsDescription: "ข้อความสำหรับชอบท่าม",
              fatcaDetailsPlaceholder: "กรอกรายละเอียด FATCA",
              questionList: "รายการคำถาม",
              questionListDescription: "จัดการรายการคำถาม FATCA",
              question: "คำถาม",
              lastModifiedDate: "วันที่แก้ไขล่าสุด",
              noQuestionsFound: "ไม่พบคำถาม",
              save: "บันทึก",
              saveSuccess: "บันทึกสำเร็จ",
              addQuestionButton: "เพิ่มคำถาม",
              deleteModalTitle: "ลบคำถาม",
              deleteModalContent: "คุณต้องการลบคำถามนี้หรือไม่?",
              cancel: "ยกเลิก",
              confirmDelete: "ยืนยันลบ",
              deleteSuccess: "ลบคำถามสำเร็จ",
              addQuestion: {
                title: "เพิ่มคำถาม",
                home: "หน้าแรก",
                frontStoreManagement: "จัดการ Front store",
                frontStoreDetail: "รายละเอียด",
                questionInfo: "ข้อมูลคำถาม",
                question: "คำถาม",
                choices: "ตัวเลือก",
                choicesInstruction1:
                  "กรุณาเลือก Checkbox ด้านหน้าตัวเลือกที่เป็นผลเฉลยของคำถาม",
                choicesInstruction2:
                  "ระบบจะตรวจสอบและกันไม่ให้ผู้ที่ตอบผิดผ่านไปขั้นตอนถัดไปของการซื้อประกัน",
                autoCorrectChoice: "เลือกคำตอบให้อัตโนมัติ",
                answerRequiredWhenAutoCorrect:
                  "กรุณาเลือกตัวเลือกที่เป็นผลเฉลยของคำถาม",
                choiceLabel: "ตัวเลือก",
                addChoice: "เพิ่มตัวเลือก",
                cancel: "ยกเลิก",
                addQuestion: "เพิ่มคำถาม",
                editTitle: "แก้ไขคำถาม",
                save: "บันทึก",
                saveSuccess: "เพิ่มคำถามสำเร็จ",
                editSuccess: "แก้ไขคำถามสำเร็จ",
              },
            },
          },
          authentication: {
            LoginPage: {
              or: "หรือ",
              title: "My Benefit",
              title1: "กรอกอีเมลรับรหัส OTP เพื่อเข้าสู่ระบบ",
              title2: "กรอกอีเมลรับรหัส OTP เพื่อลงทะเบียนใช้งาน",
              emailField: "อีเมล",
              getOtp: "รับรหัส OTP",
              invalidEmail: "รูปแบบอีเมลไม่ถูกต้อง",
              signInWithAzureAd: "เข้าสู่ระบบด้วย Azure AD",
              logoutAzureAd: "ออกจากระบบ Azure AD",
            },
            VerifyOtp: {
              title: "กรอกรหัส OTP เพื่อเข้าสู่ระบบ",
              otpInfo:
                "กรอกรหัส OTP ที่ได้รับทาง {{currentEmail}} (OTP มีอายุการใช้งาน {{otpExpireInMin}} นาที)",
              otp: "OTP",
              refCode: "เลขอ้างอิง:{{refCode}}",
              notReceiveOtp: "ไม่ได้รหัส OTP?",
              retryOtp: "ขอ OTP อีกครั้ง",
              canRetryIn: "ขออีกครั้งใน {{timeLeft}} วินาที",
              login: "เข้าสู่ระบบ",
              changeEmail: "เปลี่ยนอีเมล",
              home: "กลับไปหน้าแรก",
              otpMustNumber: "รูปแบบ otp ไม่ถูกต้อง",
              ok: "ตกลง",
            },
          },
          enrollment: {
            index: {
              title: "เปิด/ปิด ประกันและ Package",
              status: "สถานะ",
              cycleName: "ชื่อรอบ",
              year: "ปีที่ใช้งาน",
              reset: "รีเซ็ต",
              filter: "กรอง",
              home: "หน้าแรก",
              startDate: "วันเริ่ม",
              endDate: "วันสิ้นสุด",
              amount: "ผู้เข้าร่วม",
              state: {
                name: "สถานะ",
                all: "ทั้งหมด",
                draft: "แบบร่าง",
                published: "เผยแพร่",
                publishing: "กำลังเผยแพร่",
                pending: "รอแก้ไข",
                active: "ใช้งาน",
                closed: "ปิด",
              },
              updatedAt: "วันที่แก้ไขล่าสุด",
              createEnrollment: "สร้างการลงทะเบียน",
              deleteTitle: "ลบข้อมูล",
              deleteModalInfo1: "ข้อมูล",
              enrollment: "การลงทะเบียนปี {{year}}",
              deleteModalInfo2: "จะถูกลบและไม่สามารถกู้คืนได้",
              closeDeleteModal: "ปิดหน้าต่างนี้",
            },
            CreateEnrollmentModal: {
              title: "สร้างการลงทะเบียน",
              description: "โปรดระบุปีที่ใช้งาน",
              year: "ปีที่ใช้งาน",
              cancel: "ยกเลิก",
              error: {
                title: "เกิดข้อผิดพลาด",
                close: "ปิดหน้าต่างนี้",
              },
            },
            detail: {
              title: "การลงทะเบียนปี {{year}}",
              step: "ขั้นตอน ({{step}}/{{of}})",
              draft: "แบบร่าง",
              pending: "รอแก้ไข",
              published: "เผยแพร่",
              publishing: "กำลังเผยแพร่",
              active: "ใช้งาน",
              closed: "ปิด",
              home: "หน้าแรก",
              enrollment: "การลงทะเบียน",
              state: {
                1: "กำหนดช่วงเวลา",
                2: "ตรวจสอบผู้เข้าร่วม",
                3: "จัดการแบบประกัน",
                4: "จัดการแผนประกัน",
                5: "จัดชุดข้อมูล",
                6: "ตรวจสอบและเผยแพร่",
              },
              pendingText:
                "ถ้าพบข้อมูลประกันไม่ถูกต้อง กรุณากดแจ้งแก้ไขแบบประกันและติดต่อ Zennite ให้แก้ไขแบบประกันให้ถูกต้องก่อนดำเนินการต่อ",
              pendingButton: "แจ้งแก้ไขแบบประกัน",
              cancel: "ยกเลิก",
              pendingModalText1:
                "ระบบจะล็อคไม่ให้เผยแพร่ Enrollment นี้ได้ จนกว่าจะมีการแก้ไขข้อมูลประกันจาก Zennite",
              pendingModalText2:
                "* หลังจากกดแจ้งแก้ไขแล้ว กรุณาระบุรายละเอียดการแก้ไขผ่านช่องทางการติดต่อของ Zennite",
              generateLinkDescription:
                "เมื่อเผยแพร่การลงทะเบียนแล้ว สามารถนำ Link แบบประกันหรือแพ็กเกจ ไปแชร์ตาม platform อื่นๆได้",
              generateLinkButton: "ดูรายละเอียด Link",
              generateLinkModal: {
                title: "รายชื่อประกันในรอบ “{{name}}”",
                name: "ชื่อแบบประกัน/แพ็กเกจ",
                companyName: "บริษัท",
                type: "ประเภท",
                insuranceName: "ชื่อแบบประกัน",
                shortDescription: "รายละเอียดแบบย่อ",
                filter: "กรอง",
                reset: "รีเซ็ต",
                all: "ทั้งหมด",
                package: "แพ็กเกจ",
                copySuccess: "คัดลอกลิงก์ไปที่ Clipboard แล้ว",
                copyFailed: "คัดลอกลิงก์ไปที่ Clipboard ไม่สำเร็จ",
              },
              editShortDescriptionModal: {
                title: "แก้ไขข้อมูลประกัน",
                name: "ชื่อแบบประกัน",
                company: "บริษัท",
                type: "ประเภท",
                shortDescription:
                  "รายละเอียดแบบย่อ (ใช้สำหรับประกันที่กดลิงก์จากเว็บภายนอก)",
                cancel: "ยกเลิก",
                save: "บันทึก",
              },
            },
            PeriodSetting: {
              enrollmentPeriodSetting: "กำหนดช่วงเวลาของการลงทะเบียน",
              updatedAt: "แก้ไขข้อมูลล่าสุดเมื่อ: {{updatedAt}}",
              cycleName: "ชื่อรอบ",
              startDate: "วันเริ่มต้นที่ให้เลือกประกันได้",
              endDate: "วันสุดท้ายที่ให้เลือกประกันได้",
              startDateLessThanEndDate: "startDate ต้องน้อยกว่า endDate",
              existingAttendeeSelectionPeriodInDays:
                "ระยะเวลาที่ให้พนักงานเก่าเลือกได้",
              incomingAttendeeSelectionPeriodInDays:
                "ระยะเวลาที่ให้พนักงานเข้าระหว่างปีเลือกได้",
              existingAttendeeSelectionPeriodInDaysInfo:
                "นับตั้งแต่วันที่เริ่มให้เลือกประกัน",
              incomingAttendeeSelectionPeriodInDaysInfo:
                "นับตั้งแต่วันที่มีสถานะพนักงาน",
              saveAndNext: "บันทึกและถัดไป",
              save: "บันทึก",
              saveSuccess: "บันทึกสำเร็จ",
              masterInsurance: "ชุดแบบประกัน",
              noti:
                "เมื่อบันทึกแล้ว ข้อมูลที่แสดงใน App จะได้รับการอัปเดตทันที",
              alertNoLimit: {
                desc1:
                  "โหมด Freelance แนะนำให้เลือก <b>ไม่จำกัดระยะเวลาเลือกประกัน</b> เพื่อเปิดให้ผู้ใช้ซื้อประกันได้ตลอดโดยไม่ต้องกำหนดวันสิ้นสุด",
              },
              isNoLimit: "ไม่จำกัดระยะเวลาเลือกประกัน",
            },
            enrollmentAttendee: {
              alertSyncData: {
                desc1:
                  "ปุ่ม <b>“อัปเดตข้อมูล”</b> ใช้สำหรับโหมด Enterprise เท่านั้น",
                desc2:
                  "ถ้าเป็นโหมด Freelance กดแล้วจะ Sync ข้อมูลไม่สำเร็จ เนื่องจากไม่มีการตั้งค่าเอาไว้<b>แต่ไม่ส่งผลต่อการใช้งาน</b>",
              },
              title: "ตรวจสอบผู้เข้าร่วม",
              field: "รหัสพนักงาน / ชื่อ-นามสกุล",
              reset: "รีเซ็ต",
              filter: "กรอง",
              next: "ถัดไป",
              lastUpdate: "อัพเดทข้อมูลล่าสุดเมื่อ: {{updatedAt}}",
              updateData: "อัพเดทข้อมูล",
              code: "รหัสพนักงาน",
              name: "ชื่อ - นามสกุล",
              department: "แผนก",
              position: "ตำแหน่ง",
              filterNotFound:
                "ไม่พบข้อมูลที่ค้นหา กรุณาตรวจสอบค่าในตัวกรองอีกครั้ง",
              syncModal:
                "ระบบกำลังอัพเดทข้อมูล กรุณาอย่าปิดหน้าจอนี้จนกว่าจะอัพเดทข้อมูลเสร็จ",
              noAttendee: "ไม่พบข้อมูลผู้เข้าร่วม",
              syncSuccess: "ทำรายการสำเร็จ",
              syncFail: "ทำรายการไม่สำเร็จ",
              infoText:
                "workspace ของคุณเปิดให้ผู้ใช้เลือกแบบประกันอย่างละเอียดได้ด้วยตัวเอง จึงไม่จำเป็นต้องจัดการแผนประกันในขั้นตอนนี้ (สามารถกดถัดไปได้เลย)",
            },
            enrollmentInsurancePackage: {
              title: "จัดการแผนประกัน",
              name: "ชื่อแพ็กเกจ",
              coverageLevel: "ระดับความคุ้มครอง",
              insuranceName: "ประกัน {{insuranceName}}",
              remark: "หมายเหตุ",
              next: "ถัดไป",
              lastUpdate: "อัพเดทข้อมูลล่าสุดเมื่อ: {{updatedAt}}",
              insuranceFor: {
                employee: "ข้อมูลแผนประกันของพนักงาน",
                family: "ข้อมูลแผนประกันของครอบครัว",
              },
              infoText:
                "workspace ของคุณเปิดให้ผู้ใช้เลือกแบบประกันอย่างละเอียดได้ด้วยตัวเอง จึงไม่จำเป็นต้องจัดการแผนประกันในขั้นตอนนี้ (สามารถกดถัดไปได้เลย)",
            },
            attendeeGrouping: {
              file: "แนบไฟล์",
              detail: "รายละเอียดแบบประกันสำหรับแสดงใน App ",
              deletetitle: "ลบข้อมูล",
              deletetitle1:
                "ข้อมูล รายละเอียดแบบประกันสำหรับแสดงใน App  จะถูกลบและไม่สามารถกู้คืนได้",
              cancel: "ปิดหน้าต่างนี้",
              title: "จัดชุดข้อมูล",
              info: "คะแนนที่ใส่ในช่องนี้คิดรวมมูลค่าของประกันเริ่มต้นไว้ด้วย",
              currentScore: "คะแนนที่มีสำหรับรอบนี้",
              unit: "คะแนน",
              type: "วิธีการเลือกแบบประกัน",
              saveAndNext: "บันทึกและถัดไป",
              save: "บันทึก",
              saveSuccess: "บันทึกสำเร็จ",
              ok: "ตกลง",
              titleError: "ไม่สามารถบันทึกข้อมูลได้",
              errorDetail1:
                "มูลค่ารวมของประกันเริ่มต้นในแต่ละกลุ่มพนักงานต้องไม่เกินคะแนนที่พนักงานได้รับ",
              errorDetail2:
                "กรุณาแก้ไข “คะแนนที่มีสำหรับรอบนี้” หรือเลือกประกันเริ่มต้นของกลุ่มพนักงานต่อไปนี้ใหม่",
              custom: "ให้เลือกเอง",
              package: "ให้เลือกจาก package ประกัน",
              none: "ไม่เปิดให้เลือก",
              packageHeader: "แพ็กเกจประกันที่เลือกได้",
              noti:
                "เมื่อบันทึกแล้ว ข้อมูลที่แสดงใน App จะได้รับการอัปเดตทันที",
              saveConfirmTitle: "ต้องการบันทึกข้อมูลหรือไม่",
              saveConfirmDescription:
                "เมื่อบันทึกแล้ว ข้อมูลที่แสดงใน App จะได้รับการอัปเดตทันที โปรดตรวจสอบความถูกต้องของข้อมูลก่อนดำเนินการ",
              cancelConfirmModal: "ยกเลิก",
              InsuranceList: {
                add: "เลือกประกัน",
                deleteInsuranceModalTitle: "ลบแบบประกัน",
                deleteInsuranceModalInfo1: "ข้อมูลแบบประกัน",
                deletePackageModalTitle: "ลบ Package",
                deletePackageModalInfo1: "ข้อมูล Package",
                deleteModalInfo2: "จะถูกลบและไม่สามารถกู้คืนได้",
                close: "ปิดหน้าต่างนี้",
                confirmDelete: "ลบข้อมูล",
                insuranceName: "ชื่อแบบประกัน",
                packageName: "ชื่อ Package",
                remark: "หมายเหตุ",
                deleteSuccess: "ทำรายการสำเร็จ",
                modalInsuranceTitle: "เลือกแบบประกัน {{type}} ให้ {{group}}",
                modalPackageTitle: "เลือก Package ให้พนักงานประจำ",
                modalCancel: "ยกเลิก",
                modalConfirm: "เลือก",
                delete: "ลบ",
                insuranceTypeHeader: "แบบประกัน {{type}} ที่เลือกได้",
                packageHeader: "เลือกแพ็กเกจให้ {{group}}",
                default: "ค่าเริ่มต้น",
                isActive: "ใช้งาน",
                companyName: "บริษัทประกัน",
              },
              InsuranceSelectorModal: {
                insuranceName: "ชื่อแบบประกัน",
                packageName: "ชื่อ Package",
                remark: "หมายเหตุ",
              },
            },
            validate_and_published: {
              index: {
                previewAlert: {
                  desc1:
                    "ปุ่ม <b>“Preview”</b> ใช้สำหรับโหมด Enterprise เท่านั้น ",
                  desc2:
                    "ถ้าเป็นโหมด Freelance จะดูตัวอย่างได้ที่เมนู Front store แทน",
                },
                insuranceDetail: "รายละเอียดแบบประกัน",
                title: "ตรวจสอบและเผยแพร่",
                period: "ช่วงเวลา",
                edit: "แก้ไข",
                warningMessage:
                  "เมื่อเผยแพร่แล้วจะไม่สามารถแก้ไขข้อมูลการลงทะเบียนรอบนี้ได้อีก (นอกจากการเพิ่มระยะเวลาใช้งาน) กรุณาตรวจสอบข้อมูลให้ครบถ้วนก่อนเผยแพร่การลงทะเบียน",
                cycleName: "ชื่อรอบ",
                year: "ประจำปี",
                startDate: "วันเริ่มต้นใช้งาน",
                endDate: "วันสิ้นสุดการใช้งาน",
                existingEnrollmentDaysLeft:
                  "ระยะเวลาเลือกประกันสำหรับพนักงานประจำ",
                incomingEnrollmentDaysLeft:
                  "ระยะเวลาเลือกประกันสำหรับพนักงานใหม่",
                days: "วัน",
                insuranceDetails: "รายละเอียดการเลือกประกัน",
                score: "คะแนน",
                type: "วิธีการเลือกแบบประกัน",
                published: "เผยแพร่",
                publishing: "กำลังเผยแพร่",
                preview: "Preview",
                employees: "พนักงาน",
                code: "รหัสพนักงาน",
                name: "ชื่อ - นามสกุล",
                department: "แผนก",
                position: "ตำแหน่ง",
                insuranceName: "ชื่อแบบประกัน",
                remark: "หมายเหตุ",
                default: "ค่าเริ่มต้น",
                employeeDetail: "รายละเอียดพนักงาน",
                customTitle: "แบบประกัน {{nameTitle}} ที่เลือกได้",
                packageTitle: "Package {{nameTitle}}",
                publishEnrollment: "เผยแพร่การลงทะเบียน",
                cancel: "ยกเลิก",
                publishModalText:
                  "เมื่อเผยแพร่แล้วจะไม่สามารถแก้ไขข้อมูลการลงทะเบียนรอบนี้ได้อีก",
                publishModalText2:
                  "กรุณาตรวจสอบข้อมูลให้ครบถ้วนก่อนเผยแพร่การลงทะเบียน",
                errorTitle: "เกิดข้อผิดพลาด",
                submit: "ตกลง",
                errorModalText: "มีการแก้ไขชุดข้อมูลประกันของ Enrollment นี้",
                errorModalText2:
                  "กรุณารอจนการแก้ไขชุดแบบประกันเสร็จสมบูรณ์ จากนั้นทำรายการอีกครั้ง",
                success: "ทำรายการสำเร็จ",
                errorValidateText:
                  "ไม่สามารถเผยแพร่ได้ เนื่องจากยังกรอกรายละเอียดของกลุ่มพนักงาน {{title}} ไม่ครบถ้วน",
                custom: "ให้เลือกเอง",
                package: "ให้เลือกจาก package ประกัน",
                none: "ไม่เปิดให้เลือก",
                syncEmployeeErrorOnPublishedTitle: "ไม่สามารถเผยแพร่ได้",
                syncEmployeeErrorOnPublished:
                  "ไม่สามารถดึงข้อมูลพนักงานล่าสุดได้ ทำให้ไม่สามารถเผยแพร่ได้ กรุณาตรวจสอบไฟล์ข้อมูลพนักงาน หรือติดต่อผู้ดูแลระบบ",
                publishingModal:
                  "ระบบกำลังเผยแพร่ข้อมูลการลงทะเบียน กรุณาอย่าปิดหน้าจอนี้จนกว่าจะอัพเดทข้อมูลเสร็จ",
                masterInsurance: "ชุดแบบประกัน",
                nonDefaultTitle:
                  "มีแบบประกันที่ยังไม่เลือกประกันตั้งต้นดังต่อไปนี้",
                nonDefaultDescription:
                  "ต้องการเผยแพร่โดยไม่เลือกแบบประกันตั้งต้นใช่หรือไม่",
              },
            },
            InsurancePlanValidating: {
              title: "จัดการแบบประกัน",
              name: "ชื่อแบบประกัน",
              remark: "หมายเหตุ",
              next: "ถัดไป",
              updatedAt: "อัพเดทข้อมูลล่าสุดเมื่อ: {{date}}",
              coverageLevel: "ระดับ",
              insuranceFor: {
                employee: "ข้อมูลแบบประกันของพนักงาน",
                family: "ข้อมูลแบบประกันของครอบครัว",
              },
            },
            enrollmentInsurance: {
              home: "หน้าแรก",
              enrollment: "การลงทะเบียน",
              name: "ชื่อแบบประกัน",
              insuranceType: "ประเภท",
              protectionStartDate: "วันเริ่มต้นคุ้มครอง",
              protectionEndDate: "วันสิ้นสุดคุ้มครอง",
              premium: "เบี้ยประกัน (บาท)",
              remark: "หมายเหตุ",
              description: "รายละเอียด",
              back: "ย้อนกลับ",
              isFamily: "ประกันสำหรับ",
              coverageLevel: "ระดับคววามคุ้มครอง",
              insuranceFor: {
                employee: "พนักงาน",
                family: "ครอบครัว",
              },
              previewMyPolicy: "ดูตัวอย่างหน้ากรมธรรม์ของฉัน",
              previewInsuranceDetail: "ดูตัวอย่างหน้ารายละเอียดประกัน",
            },
          },
          insurance: {
            detail: {
              title: "ชุดแบบประกันปี {{year}}",
              step: "ขั้นตอน ({{step}}/{{of}})",
              draft: "แบบร่าง",
              published: "เผยแพร่",
              publishing: "กำลังเผยแพร่",
              editing: "ใช้งาน",
              insuranceDetailTitle: "ข้อมูลแบบประกัน",
              packageTitle: "จัดชุดแผนประกัน",
              validateAndPublish: "ตรวจสอบและเผยแพร่",
              breadcrumbs: {
                home: "หน้าแรก",
                insurance: "จัดการชุดแบบประกัน",
              },
              manageWeightTitle: "จัดการค่าถ่วงน้ำหนัก",
            },
            SelectMasterInsurancePlansModal: {
              modalTitle: "เลือกแบบประกัน{{type}}",
              name: "ชื่อแบบประกัน",
              company: "บริษัทประกัน",
              remark: "หมายเหตุ",
              save: "เลือก",
              close: "ยกเลิก",
              riderHelp: 'เป็น Rider ของประกัน{{type}} "{{planName}}"',
            },
            InsuranceDetail: {
              notice:
                "แนะนำให้เลือกไม่เกิน 6 รายการต่อประเภท เพื่อการแสดงผลที่สวยงามบน Front Store",
              insuranceType: "แบบประกัน{{name}}",
              masterInsuranceName: "ชื่อชุดแบบประกัน",
              companyName: "บริษัทประกัน",
              duration: "ช่วงเวลาคุ้มครอง",
              protectionStartDate: "วันเริ่มต้นคุ้มครอง",
              protectionEndDate: "วันสิ้นสุดความคุ้มครอง",
              insuranceData: "ข้อมูลแบบประกัน",
              saveAndNext: "บันทึกและถัดไป",
              save: "บันทึก",
              saveSuccess: "บันทึกสำเร็จ",
              add: "เพิ่มแบบประกัน",
              insuranceFor: {
                employee: "ข้อมูลแบบประกันของพนักงาน",
                family: "ข้อมูลแบบประกันของครอบครัว",
              },
              selectHowToFillInsuranceDetail:
                "เลือกวิธีกรอกรายละเอียดแบบประกัน",
              selectForFreelance: "การกรอกแบบใหม่ใช้สำหรับลูกค้า Freelance",
              selectForFreelanceTitle: "แยกตามฟิลด์แบบละเอียด",
              selectForEnterprise: "การกรอกแบบเดิมใช้สำหรับลูกค้า Enterprise",
              selectForEnterpriseTitle: "Markdown แบบรวมช่องเดียว",
              cancel: "ยกเลิก",
              ok: "ยืนยัน",
              saveUnsuccess: "บันทึกข้อมูลไม่สำเร็จ",
              invalidDependentContent:
                "เนื่องจากไม่มีประกันหลักของประกันตามรายชื่อต่อไปนี้",
              accept: "ตกลง",
              rider: "สัญญาเพิ่มเติม",
              dependent: "ประกันหลักที่ต้องใส่เพิ่มอย่างน้อย 1 รายการ",
            },
            InsuranceList: {
              add: "เพิ่มแบบประกัน",
              deleteModalTitle: "ลบแบบประกัน",
              deleteModalInfo1: "ข้อมูลแบบประกัน",
              deleteModalInfo2: "จะถูกลบและไม่สามารถกู้คืนได้",
              close: "ปิดหน้าต่างนี้",
              confirmDelete: "ลบข้อมูล",
              name: "ชื่อแบบประกัน",
              premium: "เบี้ยเต็ม",
              remark: "หมายเหตุ",
              deleteSuccess: "ทำรายการสำเร็จ",
              cannotDeleteWhenUsedInPackage:
                "ไม่สามารถลบได้เนื่องจากถูกใช้ใน Packages",
              cannotDeleteWhenHasBeenGroup:
                "ไม่สามารถลบได้เนื่องจากถูกนำไปจัดชุดข้อมูลในการลงทะเบียน",
              saveYourPackagesFirst: "โปรดบันทึกชุดแผนประกันก่อน",
              coverageLevel: "ระดับ",
              duplicateModalTitle: "คัดลอกแบบประกัน",
              duplicateModalContent: "ต้องการคัดลอกแบบประกัน",
            },

            /* DEPRECATED */
            InsuranceForm: {
              name: "ชื่อแบบประกัน",
              info: "รายละเอียดแบบประกัน",
              nameTh: "ชื่อแบบประกัน (TH)",
              nameEn: "ชื่อแบบประกัน (EN)",
              premium: "เบี้ยประกัน (บาท)",
              remark: "หมายเหตุ",
              back: "ย้อนกลับ",
              remarkTh: "หมายเหตุ (TH)",
              remarkEn: "หมายเหตุ (EN)",
              save: "บันทึก",
              cancel: "ยกเลิก",
              breadcrumbs: {
                home: "หน้าแรก",
                insurance: "จัดการชุดแบบประกัน",
                insuranceDetail: "ชุดแบบประกันปี {{year}}",
                ipdTitle: "แบบประกัน IPD",
                opdTitle: "แบบประกัน OPD",
                dentalTitle: "แบบประกัน Dental",
              },
              success: "ทำรายการสำเร็จ",
              coverageLevel: "ระดับความคุ้มครอง",
              coverageLevelHelper:
                "*เพื่อให้ตรงตามวัตถุประสงค์ของสวัสดิการพนักงาน ถ้ามีการเลือกประกันให้ครอบครัวระบบจะคัดกรองเฉพาะแบบประกันครอบครัวที่ระดับต่ำกว่าหรือเท่ากับระดับความคุ้มครองที่เลือกให้ตัวพนักงานเองไปแสดงเท่านั้น",
              insuranceFor: "ประกันสำหรับ",
              insuranceType: "ประเภทประกัน",
              insuranceForOptions: {
                employee: "พนักงาน",
                family: "ครอบครัว",
              },
              addInsurance: "เพิ่มแบบประกัน",
            },
            /* DEPRECATED */

            InsurancePackage: {
              allPoint: "เหมา",
              add: "เพิ่ม Package",
              deleteModalTitle: "ลบ Package",
              deleteModalInfo1: "ข้อมูล Package",
              deleteModalInfo2: "จะถูกลบและไม่สามารถกู้คืนได้",
              close: "ปิดหน้าต่างนี้",
              confirmDelete: "ลบข้อมูล",
              save: "บันทึก",
              cancel: "ยกเลิก",
              back: "ย้อนกลับ",
              breadcrumbs: {
                home: "หน้าแรก",
                insurance: "จัดการชุดแบบประกัน",
                insuranceDetail: "ชุดแบบประกันปี {{year}}",
              },
              success: "ทำรายการสำเร็จ",
              newPackageHeader: "รายละเอียด Package",
              packageNameTh: "ชื่อแพ็กเกจ (TH)",
              packageNameEn: "ชื่อแพ็กเกจ (EN)",
              remarkTh: "หมายเหตุ (TH)",
              remarkEn: "หมายเหตุ (EN)",
              packageName: "ชื่อ Package",
              insuranceName: "ชื่อแบบประกัน",
              insuranceNameTh: "ชื่อแบบประกัน (TH)",
              insuranceNameEn: "ชื่อแบบประกัน (EN)",
              insuranceType: "ประเภท",
              startDate: "วันเริ่มต้นคุ้มครอง",
              endDate: "วันสิ้นสุดคุ้มครอง",
              premium: "เบี้ยประกัน (บาท)",
              description: "รายละเอียด",
              saveAndNext: "บันทึกและถัดไป",
              saveSuccess: "บันทึกสำเร็จ",

              title: "จัดชุดแผนประกัน",
              infoText0:
                "ถ้าใช้กับ Web Application ให้จัดแพ็กเกจโปรโมชันและแพ็กเกจสวัสดิการยอดนิยมที่ขั้นตอนนี้",
              infoText:
                "ถ้าบริษัทของลูกค้าให้พนักงานเลือกประกันเป็นแบบ flex สามารถข้ามขั้นตอนนี้ได้เลย",
              tableHeader: "Package ประกัน",
              name: "ชื่อแพ็กเกจ",
              remark: "หมายเหตุ",
              packagePricingType: "เบี้ยเต็ม",
              pricingType: {
                SUM_INSURANCES: "ราคารวมของแบบประกัน",
                ALL_REMAINING: "เหมา",
                SET_OWN_PRICE: "กำหนดราคาใหม่เอง",
              },
              SUM_INSURANCES: "ราคารวมของแบบประกัน",
              ALL_REMAINING: "เหมาด้วยคะแนนที่เหลือทั้งหมด",
              SET_OWN_PRICE: "กำหนดราคาใหม่เอง",
              insuranceForOptions: {
                employee: "พนักงาน",
                family: "ครอบครัว",
              },
              insuranceFor: "ประกันสำหรับ",
              priceType: "ราคา Package",
              coverageLevel: "ระดับความคุ้มครอง",
              coverageLevelHelper:
                "*เพื่อให้ตรงตามวัตถุประสงค์ของสวัสดิการพนักงาน ถ้ามีการเลือกประกันให้ครอบครัวระบบจะคัดกรองเฉพาะแบบประกันครอบครัวที่ระดับต่ำกว่าหรือเท่ากับระดับความคุ้มครองที่เลือกให้ตัวพนักงานเองไปแสดงเท่านั้น",
              packageFor: {
                employee: "ข้อมูลแพ็กเกจของพนักงาน",
                family: "ข้อมูลแพ็กเกจของครอบครัว",
              },
              level: "ระดับ",
              duplicateModalTitle: "คัดลอกแพ็กเกจ",
              duplicateModalContent: "ต้องการคัดลอกแพ็กเกจ",
              requiredPackage: "แพ็กเกจต้องมีข้อมูลประกันอย่างน้อย 1 ประเภท",
              cannotDeleteWhenHasBeenGroup:
                "ไม่สามารถลบได้เนื้องจากถูกนำไปจัดชุดข้อมูลในการลงทะเบียน",
              invalidDependentHelp: "ไม่มีประกันหลักอยู่ใน package",
              noMainInsurance: "ไม่มีประกันหลัก",
            },
            insurancePackages: {
              ViewInsurance: {
                name: "ชื่อ",
                type: "ประเภท",
                startDate: "วันเริ่มต้นคุ้มครอง",
                endDate: "วันสิ้นสุดคุ้มครอง",
                premium: "เบี้ยประกัน (บาท)",
                remark: "หมายเหตุ",
                description: "รายละเอียด",
              },
            },
            InsurancePreview: {
              warning:
                "หลังจากเผยแพร่แล้วถ้ามีการแก้ไขจะกระทบกับการทำงานของ HR กรุณาตรวจสอบข้อมูลให้ครบถ้วนก่อนเผยแพร่",
              title: "ตรวจสอบและเผยแพร่",
              subtitle1: "ช่วงเวลา",
              subtitle2: "ข้อมูลชุดแบบประกัน",
              sortByType: "แบ่งตามประเภท",
              startDate: "วันเริ่มต้นคุ้มครอง",
              endDate: "วันสิ้นสุดคุ้มครอง",
              tab1: "แบ่งตามประเภท",
              tab2: "แบ่งตามแพ็กเกจ",
              notFoundPackage: "ไม่พบข้อมูล Package",
              notFoundData: "ไม่พบข้อมูล",
              edit: "แก้ไข",
              cancel: "ยกเลิก",
              publish: "เผยแพร่",
              rePublish: "เผยแพร่อีกครั้ง",
              modalTitle: "เผยแพร่การจัดชุดแผนประกัน",
              insuranceName: "ชื่อแบบประกัน",
              insuranceRemark: "หมายเหตุ",
              packagePricingType: "ราคา Package",
              SUM_INSURANCES: "ราคารวมของแบบประกัน",
              ALL_REMAINING: "เหมาด้วยคะแนนที่เหลือทั้งหมด",
              rePublishModalTitleWarning: "เผยแพร่ชุดแบบประกันใหม่อีกครั้ง",
              rePublishModalWarning:
                "การเผยแพร่แบบประกันครั้งนี้ จะส่งผลให้ประกันทั้งหมดที่ HR จัดกลุ่มไว้หายไปและต้องทำการจัดกลุ่มใหมทั้งหมด",
              success: "ทำรายการสำเร็จ",
              insuranceTableHeader: "แบบประกัน {{name}} ที่เลือกได้",
              insuranceFor: {
                employee: "ข้อมูลชุดแบบประกันพนักงาน",
                family: "ข้อมูลชุดแบบประกันครอบครัว",
              },
              pricingType: "เบี้ยเต็ม",
              level: "ระดับ",
              pricingTypeText: {
                SUM_INSURANCES: "ราคารวมของแบบประกัน",
                ALL_REMAINING: "เหมา",
                SET_OWN_PRICE: "กำหนดราคาใหม่เอง",
              },
              noRowInsurance: "ไม่พบข้อมูลแบบประกัน {{name}}",
              noRowInsurancePackage: "ไม่พบข้อมูล Package",
              insuranceType: {
                IPD: "IPD",
                OPD: "OPD",
                DENTAL: "Dental",
                ACCIDENT: "อุบัติเหตุ",
                HEALTH: "สุขภาพ",
                ANNUITY: "บำนาญ",
              },
              detail: {
                insuranceName: "ชื่อแบบประกัน",
                insuranceCompany: "บริษัทประกัน",
                insuranceType: "ประเภท",
                remark: "หมายเหตุ",
                back: "ย้อนกลับ",
                previewMyPolicy: "ดูตัวอย่างหน้ากรมธรรม์ของฉัน",
                previewInsuranceDetail: "ดูตัวอย่างหน้ารายละเอียดประกัน",
                breadcrumbs: {
                  home: "หน้าแรก",
                  insurance: "จัดการชุดแบบประกัน",
                  insuranceDetail: "ชุดแบบประกันปี {{year}}",
                },
              },
            },
            FreelanceInsuranceForm: {
              breadcrumbs: {
                home: "หน้าแรก",
                insurance: "จัดการชุดแบบประกัน",
                insuranceDetail: "ชุดแบบประกัน {{year}}",
              },
              tab1: "รายละเอียดแบบประกัน",
              tab2: "ข้อมูลสำหรับ Custom package เอง",
              tab3: "ตารางกรมธรรม์",
              cancel: "ยกเลิก",
              save: "บันทึก",
              detail: {
                info: "รายละเอียดแบบประกัน",
                companyName: "บริษัทประกัน",
                insuranceName: "ชื่อแบบประกัน",
                remark: "หมายเหตุ",
                active: "ใช้งาน",
                addItem: "เพิ่มรายการ",
                order: "รายการที่",
                orderName: "ชื่อรายการ",
                detail: "รายละเอียด",
                summaryTable: "ตารางสรุป",
                listOfBenefits: "รายการผลประโยชน์",
                compensationList: "รายการค่าชดเชย",
                insurancePlanDetail: "รายละเอียดแผนประกัน",
                summaryBenefit: "สรุปผลประโยชน์",
                policyAndConditions: "เงื่อนไขกรมธรรม์",
                termsAndBenefits: "ข้อกำหนดและผลประโยชน์",
                documentRequirementsAndBenefits: "เอกสารข้อกำหนดและผลประโยชน์",
                policyInformation:
                  "ข้อมูลกรมธรรม์ (สำหรับแสดงในกรมธรรม์ของฉัน)",
                acceptPdf: "รองรับไฟล์ .pdf",
                browseFile: "แนบไฟล์",
              },
              infoCustomPackage: {
                info: "ค่าที่ใช้สำหรับเลือกแบบประกัน",
                accident: {
                  byAccident: "เสียชีวิตจากอุบัติเหตุ",
                  insuranceMoney: "เงินเอาประกันภัย",
                },
                health: {
                  ipd: "ค่ารักษาผู้ป่วยใน (IPD)",
                  opd: "โอพีดี พลัส+ (OPD+)",
                },
                annuity: {
                  ipd: "ค่ารักษาผู้ป่วยใน (IPD)",
                },
                amount: "จำนวน",
                detail: "รายละเอียด",
              },
              compensationTable: {
                info: "Insurance premium",
              },
            },
            ManageWeightForm: {
              title: "จัดการค่าถ่วงน้ำหนัก",
              insuranceType: "แบบประกัน{{name}}",
              alert:
                "ค่าถ่วงน้ำหนักใช้สำหรับคำนวณผลการค้นหาแบบประกันที่ Web application โดยกำหนดค่าถ่วงน้ำหนักในช่วง 1-5 ให้ประกันแต่ละรายการ ซึ่งยิ่งมีค่าถ่วงน้ำหนักมากยิ่งมีโอกาสแสดงเป็นผลการค้นหามากขึ้นตามไปด้วย",
              table: {
                template: "แบบประกัน",
                name: "ชื่อแบบประกัน",
                value: "ค่าถ่วงน้ำหนัก",
              },
              saveAndNext: "บันทึกและถัดไป",
              save: "บันทึก",
              saveSuccess: "ทำรายการสำเร็จ",
            },
          },
          roles: {
            index: {
              title: "กำหนดสิทธิ",
              columnTitle: "บทบาท",
              home: "หน้าแรก",
              addButton: "เพิ่มบทบาท",
              list: "กำหนดสิทธิ",
              deleteRole: "ข้อมูล บทบาท จะถูกลบและไม่สามารถกู้คืนได้",
              deletedRole: "ลบข้อมูล",
              description: "คำอธิบาย",
              amount: "จำนวนผู้ใช้",
              updatedAt: "แก้ไขล่าสุด",
              deleteRoleSuccess: "ลบข้อมูลสำเร็จ",
              alreadyInUse: "ไม่สามารถลบได้ มีผู้ดูแลระบบใช้งานอยู่",
              cancel: "ปิดหน้าต่างนี้",
              delete: "ลบข้อมูล",
            },
            new: {
              addRole: "เพิ่มบทบาท",
              role: "บทบาท",
              home: "หน้าแรก",
              title: "ข้อมูลทั่วไป",
              detail: "รายละเอียดบทบาท",
              scope: "ขอบเขตการใช้งานระบบ",
              roleTitle: "ชื่อบทบาท",
              description: "คำอธิบาย",
              sync: "รับแจ้งเตือนเมื่อการ Sync ไม่สำเร็จ",
              read: "ดูข้อมูล",
              edit: "สร้าง / แก้ไข / ลบ",
              createAndEdit: "สร้าง / แก้ไข",
              editInfo: "แก้ไขข้อมูล",
              editOnly: "แก้ไข",
              exportReport: "ออกรายงาน",
              adminManage: "เมนูเพิ่ม/ลด Admin",
              permissionManage: "เมนูกำหนดสิทธิ",
              masterInsurancePlanManage: "เมนูเพิ่ม/ลด ข้อมูลแบบประกัน",
              insuranceManagement: "เมนูจัด Package และจัด Weight",
              enrollmentManage: "เมนูเปิด/ปิด ประกันและ Package",
              frontStoreManage: "เมนูจัดการ Front store",
              insuranceCompanyManage: "เมนูเพิ่ม/ลด บริษัทประกัน",
              occupationManage: "เมนูเพิ่ม/ลด อาชีพ",
              orderManage: "เมนูคำสั่งซื้อ",
              overdueTransactionManage: "เมนูรายการค้างชำระ",
              nameChangeTransactionManage: "เมนูคำขอเปลี่ยนชื่อ",
              brokerManage: "เมนูเพิ่ม/ลด Broker",
              missionManage: "เมนูภารกิจ",
              userManagement: "เมนูข้อมูลลูกค้า",
              leadManage: "เมนู Log ค้นหาประกัน",
              insuranceTransactionManage: "เมนูสถานะกรมธรรม์",
              paymentTransactionManage: "เมนูการชำระเงิน",
              reportManage: "เมนูออกรายงาน",
              notificationManage: "เมนูจัดการการแจ้งเตือน",
              workspaceManage: "เมนูเพิ่ม/ลด Workspace",
              settingManage: "เมนูการตั้งค่า",
              cancel: "ยกเลิก",
              save: "บันทึก",
              cancelEdit: "ยกเลิกการแก้ไขข้อมูล",
              cancelConfirm:
                "ข้อมูลปัจจุบันจะไม่ถูกบันทึก และไม่สามารถกู้คืนได้",
              close: "ปิดหน้าต่างนี้",
              canceledEdit: "ยกเลิกการแก้ไข",
            },
            edit: {
              indexTitle: "บทบาท",
              home: "หน้าแรก",
              role: "บทบาท",
              editRole: "แก้ไขบทบาท",
              cancelEdit: "ยกเลิกการแก้ไขข้อมูล",
              cancelConfirm:
                "ข้อมูลปัจจุบันจะไม่ถูกบันทึก และไม่สามารถกู้คืนได้",
              close: "ปิดหน้าต่างนี้",
              canceledEdit: "ยกเลิกการแก้ไข",
              detail: "รายละเอียดบทบาท",
              scope: "ขอบเขตการใช้งานระบบ",
              cancel: "ยกเลิก",
              save: "บันทึก",
              roleTitle: "ชื่อบทบาท",
              description: "คำอธิบาย",
            },
          },
          insurances: {
            index: {
              home: "หน้าแรก",
              title: "จัด Package และจัด Weight",
              addButton: "สร้างชุดแบบประกัน",
              list: "จัด Package และจัด Weight",
              name: "ชื่อชุดแบบประกัน",
              year: "ปีที่ใช้งาน",
              amount: "จำนวนแบบประกัน",
              updatedAt: "วันที่แก้ไขล่าสุด",
              status: "สถานะ",
              modalDescription:
                "โปรดระบุปีที่ใช้งาน (ปีที่ใช้งานต้องไม่ซ้ำกับที่มีอยู่แล้วในระบบ)",
              duplicateTitle: "คัดลอกชุดแบบประกัน",
              duplicateDescription:
                "ระบบจะคัดลอกชุดแบบประกัน <b>{{year}}</b> มาสร้างเป็นต้นแบบของชุดแบบประกันใหม่ เพื่อให้แก้ไขและใช้งานต่อไป โปรดระบุปีที่ใช้งาน",
              cancel: "ยกเลิก",
              duplicateSuccess: "ทำรายการสำเร็จ",
              alreadyInUse: "ไม่สามารถลบได้ มีชุดแบบประกันปีนี้แล้ว",
              reset: "รีเซ็ต",
              filter: "กรอง",
              reEditing: "แก้ไขการจัดชุดประกันที่เผยแพร่แล้ว",
              reEditingInfo:
                "การแก้ไขอาจส่งผลกระทบต่อ Enrollment ที่มีอยู่ในระบบ ต้องการดำเนินการต่อหรือไม่",
              edit: "แก้ไข",
              deleteTitle: "ลบชุดแบบประกัน",
              deleteSuccess: "ทำรายการสำเร็จ",
              deleteDescription: "ต้องการลบข้อมูลชุดแบบประกันปี {{year}}",
              state: {
                all: "ทั้งหมด",
                draft: "แบบร่าง",
                published: "เผยแพร่",
                publishing: "กำลังเผยแพร่",
                editing: "แก้ไข",
                active: "ใช้งาน",
                closed: "ปิด",
              },
            },
            package: {
              new: {
                save: "บันทึก",
                cancel: "ยกเลิก",
                name: "ชื่อ Package",
                ipd: "ประกัน IPD",
                opd: "ประกัน OPD",
                dental: "ประกัน Dental",
                remark: "หมายเหตุ",
              },
            },
          },
          settings: {
            index: {
              home: "หน้าแรก",
              settingMenu: "การตั้งค่าระบบ",
              title: "ตั้งค่าข้อมูลเกี่ยวกับ Belive",
              titleDetail:
                "รายละเอียดจะนำไปแสดงในหน้า ตั้งค่า -> เกี่ยวกับ Belive ของแอปพลิเคชั่น",
              logo: "โลโก้บริษัท",
              logoDetail: "แนะนำให้ใช้รูป .jpg ขนาดอย่างน้อย 100 x 100 px ",
              syncSetting: "ตั้งค่าการ Sync ข้อมูลพนักงาน",
              syncSettingDetail:
                "ข้อมูลพนักงานจะถูกใช้ในขั้นตอนการสร้าง Enrollment ของ HR",
              reportSetting: "ตั้งค่าการสร้างรายงานอัตโนมัติ",
              reportSettingDetail: "ใช้ในขั้นตอนการสร้างรายงานอัตโนมัติของระบบ",
              createReport: "สร้างรายงานทุก",
              addImage: "เพิ่มรูป",
              editImage: "แก้ไข",
              hostUrl: "Host URL",
              port: "Port",
              username: "Username",
              password: "Password",
              name: "ชื่อบริษัท",
              nameTh: "ชื่อบริษัท (Th)",
              nameEn: "ชื่อบริษัท (En)",
              description: "รายละเอียดบริษัท",
              descriptionTh: "รายละเอียดบริษัท (Th)",
              descriptionEn: "รายละเอียดบริษัท (En)",
              email: "อีเมล",
              phoneNumber: "เบอร์โทรศัพท์",
              cancel: "ยกเลิก",
              save: "บันทึก",
              saveSuccess: "ทำรายการสำเร็จ",
              syncEmData: "Sync ข้อมูลพนักงานทุก",
              cancelEdit: "ยกเลิกการแก้ไขข้อมูล",
              cancelConfirm:
                "ข้อมูลปัจจุบันจะไม่ถูกบันทึก และไม่สามารถกู้คืนได้",
              close: "ปิดหน้าต่างนี้",
              canceledEdit: "ยกเลิกการแก้ไข",
            },
          },
          reports: {
            index: {
              home: "หน้าแรก",
              reportMenu: "ออกรายงาน",
              columns: {
                year: "ปีที่ใช้งาน",
                insuranceCompanyName: "บริษัทประกัน",
                createReportDate: "วันที่สร้างรายงาน",
                outgoingCustomerAmount: "แจ้งออก",
                incomingCustomerAmount: "แจ้งเข้า",
                sendStatus: "ส่งแล้ว",
              },
              modal: {
                title: "ปรับสถานะรายงาน",
                description: "ปรับสถานะการส่งรายงานเป็น",
                statusSend: "ส่งแล้ว",
                statusNotSend: "ยังไม่ได้ส่ง",
                cancelButtonLabel: "ยกเลิก",
                okButtonLabel: "ยืนยัน",
              },
            },
          },
          marketplaceReports: {
            index: {
              home: "หน้าแรก",
              reportMenu: "ออกรายงาน Marketplace",
              columns: {
                year: "ปีที่ใช้งาน",
                insuranceCompanyName: "บริษัทประกัน",
                createReportDate: "วันที่สร้างรายงาน",
                outgoingCustomerAmount: "แจ้งออก",
                incomingCustomerAmount: "แจ้งเข้า",
                sendStatus: "ส่งแล้ว",
              },
              modal: {
                title: "ปรับสถานะรายงาน",
                description: "ปรับสถานะการส่งรายงานเป็น",
                statusSend: "ส่งแล้ว",
                statusNotSend: "ยังไม่ได้ส่ง",
                cancelButtonLabel: "ยกเลิก",
                okButtonLabel: "ยืนยัน",
              },
            },
          },
          insuranceCompanies: {
            index: {
              home: "หน้าแรก",
              title: "เพิ่ม/ลด บริษัทประกัน",
              header: "เพิ่ม/ลด บริษัทประกัน",
              addInsuranceCompany: "เพิ่มบริษัทประกัน",
              reset: "รีเซ็ต",
              filter: "กรอง",
              name: "ชื่อ",
              status: "สถานะ",
              updatedAt: "วันที่แก้ไขล่าสุด",
              columnStatus: {
                all: "ทั้งหมด",
                active: "ใช้งาน",
                closed: "ปิด",
              },
              deleteInsuranceCompany: "ลบบริษัทประกัน",
              insuranceCompanyInfo: "ข้อมูลบริษัทประกัน",
              cannotBeRestored: "จะถูกลบและไม่สามารถกู้คืนได้",
              cancel: "ปิดหน้าต่างนี้",
              delete: "ลบข้อมูล",
              notificationSuccess: "ทำรายการสำเร็จ",
            },
            new: {
              home: "หน้าแรก",
              rootPath: "บริษัทประกัน",
              title: "เพิ่มบริษัทประกัน",
              header: "ข้อมูลบริษัทประกัน",
              active: "ใช้งาน",
              save: "สร้าง",
              cancel: "ยกเลิก",
              name: "ชื่อ",
              description: "หมายเหตุ",
              notificationSuccess: "ทำรายการสำเร็จ",
              email: "อีเมล",
              phoneNumber: "เบอร์โทร",
              uploadLogo: "โลโก้บริษัทสำหรับใช้แสดงที่ Application <b>*</b>",
              uploadLgoDescription:
                "รองรับไฟล์ .jpg, .png / แนะนำ 256x256 px / ขนาดไฟล์ไม่เกิน 5 MB",
              addFile: "แนบไฟล์",
              requiredLogo: "ต้องอัพโหลดรูปโลโก้ทุกครั้ง",
              gracePeriodTitle: "จำนวนวันที่ยอมให้ค้างชำระเบี้ย",
              gracePeriodHelp:
                "ถ้าค้างชำระเกินจากที่ตั้งค่าไว้ระบบจะปรับสถานะกรมธรรม์เป็น “ไม่มีผลบังคับ” โดยอัตโนมัติ",
              broker: "Broker",
              confirm: "ยืนยัน",
            },
            edit: {
              home: "หน้าแรก",
              rootPath: "บริษัทประกัน",
              header: "ข้อมูลบริษัทประกัน",
              active: "ใช้งาน",
              save: "บันทึก",
              cancel: "ยกเลิก",
              name: "ชื่อ",
              description: "หมายเหตุ",
              notificationSuccess: "ทำรายการสำเร็จ",
              email: "อีเมล",
              phoneNumber: "เบอร์โทร",
              uploadLogo: "โลโก้บริษัทสำหรับใช้แสดงที่ Application",
              uploadLgoDescription:
                "รองรับไฟล์ .jpg, .png / แนะนำ 256x256 px / ขนาดไฟล์ไม่เกิน 5 MB",
              addFile: "แนบไฟล์",
              requiredLogo: "ต้องอัพโหลดรูปโลโก้ทุกครั้ง",
              gracePeriodTitle: "จำนวนวันที่ยอมให้ค้างชำระเบี้ย",
              gracePeriodHelp:
                "ถ้าค้างชำระเกินจากที่ตั้งค่าไว้ระบบจะปรับสถานะกรมธรรม์เป็น “ไม่มีผลบังคับ” โดยอัตโนมัติ",
              broker: "Broker",
              tab1: "ข้อมูลบริษัทประกัน",
              tab2: "คำถามก่อนซื้อประกัน",
              tab3: "สิทธิ์ในการมองเห็นข้อมูล",
            },
            question: {
              index: {
                header: "รายการคำถาม",
                question: "คำถาม",
                updatedAt: "วันที่แก้ไขล่าสุด",
                reset: "รีเซ็ต",
                filter: "กรอง",
                addQuestion: "เพิ่มคำถาม",
                deleteQuestion: "ลบคำถาม",
                cannotBeRestored: "จะถูกลบและไม่สามารถกู้คืนได้",
                cancel: "ปิดหน้าต่างนี้",
                delete: "ลบข้อมูล",
                notificationSuccess: "ทำรายการสำเร็จ",
              },
              new: {
                title: "เพิ่มคำถาม",
                home: "หน้าแรก",
                rootPath: "บริษัทประกัน",
                header: "ข้อมูลคำถาม",
                save: "บันทึก",
                cancel: "ยกเลิก",
                question: "คำถาม",
                choices: "ตัวเลือก",
                choicesInstruction1:
                  "กรุณาเลือก Checkbox ด้านหน้าตัวเลือกที่เป็นผลเฉลยของคำถาม",
                choicesInstruction2:
                  "ระบบจะตรวจสอบและกันไม่ให้ผู้ที่ตอบผิดผ่านไปขั้นตอนถัดไปของการซื้อประกัน",
                autoCorrectChoice: "เลือกคำตอบให้อัตโนมัติ",
                notificationSuccess: "ทำรายการสำเร็จ",
              },
              edit: {
                title: "รายละเอียดคำถาม",
                home: "หน้าแรก",
                rootPath: "บริษัทประกัน",
                header: "ข้อมูลคำถาม",
                save: "บันทึก",
                cancel: "ยกเลิก",
                question: "คำถาม",
                choices: "ตัวเลือก",
                choicesInstruction1:
                  "กรุณาเลือก Checkbox ด้านหน้าตัวเลือกที่เป็นผลเฉลยของคำถาม",
                choicesInstruction2:
                  "ระบบจะตรวจสอบและกันไม่ให้ผู้ที่ตอบผิดผ่านไปขั้นตอนถัดไปของการซื้อประกัน",
                autoCorrectChoice: "เลือกคำตอบให้อัตโนมัติ",
                notificationSuccess: "ทำรายการสำเร็จ",
              },
              ChoiceList: {
                answerRequiredWhenAutoCorrect:
                  "กรุณาเลือกตัวเลือกที่เป็นผลเฉลยของคำถาม",
                choiceLabel: "ตัวเลือก",
                addChoice: "เพิ่มตัวเลือก",
                title: "ลบตัวเลือก",
                cancel: "ปิดหน้าต่างนี้",
                choice: "ตัวเลือก",
                cannotBeRestored: "จะถูกลบและไม่สามารถกู้คืนได้",
              },
            },
            transactionsPermission: {
              index: {
                header: "รายชื่อผู้มีสิทธิ์มองเห็นข้อมูล",
                addUser: "เพิ่มชื่อผู้มีสิทธิ์",
                code: "รหัส",
                fullname: "ชื่อ นามสกุล",
                role: "บทบาท",
                notFound: "ไม่มีผู้มีสิทธิ์มองเห็นข้อมูล",
                deleteTitle: "ลบผู้มีสิทธิ์มองเห็นข้อมูล",
                eligible: "ผู้มีสิทธิ์",
                cannotBeRestored: "จะถูกลบและไม่สามารถกู้คืนได้",
                cancel: "ปิดหน้าต่างนี้",
                delete: "ลบข้อมูล",
                notificationSuccess: "ทำรายการสำเร็จ",
              },
              AddAdminsModal: {
                title: "รายชื่อ Admin",
                code: "รหัส",
                fullname: "ชื่อ นามสกุล",
                role: "บทบาท",
                close: "ยกเลิก",
                save: "เลือก",
                notificationSuccess: "ทำรายการสำเร็จ",
              },
            },
          },
          occupation: {
            index: {
              title: "เพิ่ม/ลด อาชีพ",
              table: "เพิ่ม/ลด อาชีพ",
              home: "หน้าแรก",
              addButton: "เพิ่มอาชีพ",
              deleteOccupation: "ลบอาชีพ",
              occupationInfo: "ข้อมูลอาชีพ",
              cannotBeRestored: "จะถูกลบและไม่สามารถกู้คืนได้",
              cancel: "ปิดหน้าต่างนี้",
              delete: "ลบข้อมูล",
              notificationSuccess: "ทำรายการสำเร็จ",
              filters: {
                firstName: "ชื่อ",
                class: "ขั้นอาชีพ",
                classAll: "ทั้งหมด",
                isActiveTitle: {
                  title: "สถานะ",
                  isActiveAll: "ทั้งหมด",
                  true: "ใช้งาน",
                  false: "ปิดใช้งาน",
                },
              },
              columns: {
                name: "ชื่อ",
                class: "ขั้นอาชีพ",
                isActiveTitle: {
                  title: "สถานะ",
                  true: "ใช้งาน",
                  false: "ปิดใช้งาน",
                },
                updatedAt: "วันที่แก้ไขล่าสุด",
              },
              reset: "รีเซ็ต",
              filter: "กรอง",
            },
            new: {
              title: "เพิ่มอาชีพ",
              title2: "อาชีพ",
              home: "หน้าแรก",
              addButton: "เพิ่มอาชีพ",
              header: "ข้อมูลอาชีพ",
              active: "ใช้งาน",
              name: "ชื่อ",
              class: "ขั้นอาชีพ",
              cancel: "ยกเลิก",
              submit: "สร้าง",
              notificationSuccess: "ทำรายการสำเร็จ",
            },
            edit: {
              title: "เพิ่มอาชีพ",
              title2: "อาชีพ",
              home: "หน้าแรก",
              addButton: "เพิ่มอาชีพ",
              header: "ข้อมูลอาชีพ",
              active: "ใช้งาน",
              name: "ชื่อ",
              class: "ขั้นอาชีพ",
              cancel: "ยกเลิก",
              submit: "บันทึก",
              notificationSuccess: "ทำรายการสำเร็จ",
            },
          },
          dynamicConfig: {
            index: {
              title: "ข้อมูลส่วนขายประกัน",
              home: "หน้าแรก",
              save: "บันทึก",
              saveSuccess: "ทำรายการสำเร็จ",
              fontFamily: "fontFamily",
              fontFamilyDescription:
                "ใส่ URL ของฟอนต์จากเว็บ googlefont.com เช่น https://fonts.google.com/specimen/Roboto",
              primary: "primary",
              primaryAccent: "primaryAccent",
              secondary: "secondary",
              secondaryAccent: "secondaryAccent",
              mainText: "mainText",
              subText: "subText",
              success: "success",
              info: "info",
              warning: "warning",
              error: "error",
              other1: "other1",
              other2: "other2",
              white: "white",
              otherAccent: "otherAccent",
              group1: "1. ตัวอักษร",
              group2: "2. ธีมสี",
              group3: "3. แนะนำการใช้งาน",
              group4: "4. หน้าหลัก",
              group5: "5. ข้อกำหนดและเงื่อนไข",
              group6: "6. การยืนยันตัวตน",
              group7: "7. ปรับแต่งประกัน",
              group8: "8. ชำระเงิน",
              group9: "9. ข้อมูลผู้ใช้งาน",
              group10: "10. ข้อมูลการติดต่อ",
              group11: "11. คำอธิบายประกัน",
              group12: "12. ลืมรหัสผ่าน",
              group13: "13. แจ้งเตือน",
              group14: "14. กรมธรรม์",
              group15: "15. การแสดงผลเมื่อระบบปิดการใช้งาน",
              loadingImageTitle: "[3.1] รูปภาพที่เปิดแอป",
              appVersionDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 485 x 485 pixel)",
              appVersionTitle: "[3.2] เวอร์ชันแอป",
              mainLogoTitle: "[3.3] โลโก้หลัก",
              mainLogoDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 169 x 30 pixel)",
              quickTourTitle: "รายการ Quick Tour",
              quickTourImageTitle: "[3.4] รูปภาพ",
              quickTourTitleTitle: "[3.5] หัวข้อ",
              quickTourInfoTitle: "[3.6] รายละเอียด",
              heroBannerTitle: "รายการแบนเนอร์",
              heroBannerImageTitle: "[4.1] รูปภาพ",
              heroBannerTitleTitle: "[4.2] หัวข้อ",
              heroBannerInfoTitle: "[4.3] รายละเอียด",
              heroBannerLinkUrlTitle: "[4.4] URL",
              backgroundImageTitle: "[4.5] รูปภาพพื้นหลัง",
              backgroundImageDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 154 x 154 pixel)",
              tutorialImageTitle: "[4.6] รูปภาพวิธีการซื้อประกัน",
              tutorialImageDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB  (แนะนำ 374 x 238 pixel)",
              tcTitle: "[5.1] หัวข้อ T&C",
              tcInfo: "[5.2] รายละเอียด T&C",
              tcConsentMessage: "[5.3] ข้อความยินยอม T&C",
              kycBannerEmailTitle: "[6.1] แบนเนอร์ KYC: กรอกอีเมล",
              kycDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 375 x 175 pixel)",
              kycBannerOtpTitle: "[6.2] แบนเนอร์ KYC: ใส่รหัส OTP",
              kycBannerPersonalInfoTitle: "[6.3] แบนเนอร์ KYC: ข้อมูลส่วนตัว",
              kycBannerConfirmPhoneNumberTitle:
                "[6.4] แบนเนอร์ KYC: ยืนยันเบอร์",
              kycBannerSuccessTitle: "[6.5] แบนเนอร์ KYC: ทำรายการสำเร็จ",
              kycHeaderSuccessTitle: "[6.6] หัวข้อ KYC สำเร็จ",
              kycInfoSuccessTitle: "[6.7] รายละเอียด KYC สำเร็จ",
              customIntroImageTitle: "[7.1] รูปภาพหน้าแนะนำ",
              customIntroImageDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 226 x 226 pixel)",
              customIntroTitleTitle: "[7.2] หัวข้อหน้าแนะนำ",
              customIntroInfoTitle: "[7.3] รายละเอียดหน้าแนะนำ",
              customDetailImageTitle: "[7.4] รูปภาพหน้าปรับแต่ง",
              customDetailImageDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 96 x 96 pixel)",
              customDetailTitleTitle: "[7.5] หัวข้อหน้าปรับแต่ง",
              customDetailInfoTitle: "[7.6] รายละเอียดหน้าปรับแต่ง",
              notificationTitle: "[7.7] หัวข้อแจ้งเตือนเมื่อคำนวณเบี้ยไม่ได้",
              notificationInfo:
                "[7.8] รายละเอียดแจ้งเตือนเมื่อคำนวณเบี้ยไม่ได้",
              buyInsuranceMultipleCompaniesImageTitle:
                "[7.9] รูปภาพหน้าซื้อประกันหลายบริษัท",
              buyInsuranceMultipleCompaniesDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 226 x 226 pixel)",
              customNoInsurancePlanImageTitle:
                "[7.10] รูปภาพหน้าปรับแต่งกรณีไม่พบแบบประกัน",
              customNoInsurancePlanImageDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 96 x 96 pixel)",
              customNoInsurancePlanTitleTitle:
                "[7.11] หัวข้อหน้าปรับแต่งกรณีไม่พบแบบประกัน",
              customNoInsurancePlanInfoTitle:
                "[7.12] รายละเอียดหน้าปรับแต่งกรณีไม่พบแบบประกัน",
              paySuccessImageTitle: "[8.1] รูปภาพชำระเงินสำเร็จ",
              paySuccessTitle: "[8.2] หัวข้อชำระเงินสำเร็จ",
              paySuccessInfo: "[8.3] รายละเอียดชำระสำเร็จ",
              paySuccessInfo2: "[8.4] รายละเอียดชำระสำเร็จ 2",
              payFailedImageTitle: "[8.5] รูปภาพชำระเงินไม่สำเร็จ",
              payFailedTitle: "[8.6] หัวข้อชำระไม่สำเร็จ",
              payFailedInfo: "[8.7] รายละเอียดชำระไม่สำเร็จ",
              payFailedInfoDescription:
                "สามารถระบุตัวแปรตัวอักษรจากระบบลงในข้อความได้ ดังนี้\n• วันที่ชำระเงินให้ใส่ค่าว่า {{payment_date}}",
              defaultProfileImageTitle: "[9.1] รูปภาพ Default profile",
              defaultProfileDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 100 x 100 pixel)",
              aboutUsInfoTitle: "[9.2] ข้อมูลเกี่ยวกับเรา",
              aboutUsTelNoTitle: "[9.3] เบอร์โทรสำหรับติดต่อ",
              aboutUsEmailTitle: "[9.4] อีเมลสำหรับติดต่อ",
              notLoginImageTitle: "[9.5] รูปภาพกรณียังไม่ Login",
              notLoginImageDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 226 x 226 pixel)",
              notLoginMessageTitle: "[9.6] ข้อความกรณียังไม่ Login",
              faqTitle: "รายการคำถามที่พบบ่อย",
              faqCategoryTitle: "[9.7] หมวดหมู่",
              faqQuestionTitle: "[9.8] คำถาม",
              faqAnswerTitle: "[9.9] คำตอบ",
              tutorialStepTitle: "ขั้นตอนการซื้อ",
              contactProcessImageTitle: "[10.1] รูปภาพขั้นตอนการซื้อ",
              contactProcessImageDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 92 x 82 pixel)",
              purchaseProcessTitleTitle: "[10.2] หัวข้อขั้นตอนการซื้อ",
              purchaseProcessInfoTitle: "[10.3] รายละเอียดขั้นตอนการซื้อ",
              tutorialStepImageTitle: "[10.4] รูปภาพ",
              tutorialStepImageDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 85 x 85 pixel)",
              tutorialStepStepTitle:
                "[10.5] ชื่อขั้นตอน (ไม่ต้องใส่หมายเลขกำกับ-ระบบจะใส่ลำดับให้อัตโนมัติ)",
              tutorialStepTitleTitle: "[10.6] หัวข้อของรายละเอียด",
              tutorialStepInfoTitle: "[10.7] รายละเอียด",
              accidentTitle: "[11.1] หัวข้อผลประโยชน์อุบัติเหตุ",
              accidentTitleTooltip: "[11.2] หัวข้อ Tooltip อุบัติเหตุ",
              accidentInfoTooltip: "[11.3] รายละเอียด Tooltip อุบัติเหตุ",
              ciTitle: "[11.4] หัวข้อผลประโยชน์โรคร้ายแรง",
              ciTitleTooltip: "[11.5] หัวข้อ Tooltip โรคร้ายแรง",
              ciInfoTooltip: "[11.6] รายละเอียด Tooltip โรคร้ายแรง",
              ipdTitle: "[11.7] หัวข้อผลประโยชน์ผู้ป่วยใน",
              ipdTitleTooltip: "[11.8] หัวข้อ Tooltip ผู้ป่วยใน",
              ipdInfoTooltip: "[11.9] รายละเอียด Tooltip ผู้ป่วยใน",
              opdTitle: "[11.10] หัวข้อผลประโยชน์ผู้ป่วยนอก",
              opdTitleTooltip: "[11.11] หัวข้อ Tooltip ผู้ป่วยนอก",
              opdInfoTooltip: "[11.12] รายละเอียด Tooltip ผู้ป่วยนอก",
              wellnessTitle: "[11.13] หัวข้อผลประโยชน์เวลเนส",
              wellnessTitleTooltip: "[11.14] หัวข้อ Tooltip เวลเนส",
              wellnessInfoTooltip: "[11.15] รายละเอียด Tooltip เวลเนส",
              annuityTitle: "[11.16] หัวข้อผลประโยชน์บำนาญ",
              annuityTitleTooltip: "[11.17] หัวข้อ Tooltip บำนาญ",
              annuityInfoTooltip: "[11.18] รายละเอียด Tooltip บำนาญ",
              forgetPassBanner1Title: "[12.1] แบนเนอร์ลืมรหัสผ่าน: ใส่อีเมล",
              forgetPassBanner2Title:
                "[12.2] แบนเนอร์ลืมรหัสผ่าน: ตั้งรหัสผ่านใหม่",
              forgetPassBanner3Title:
                "[12.3] แบนเนอร์ลืมรหัสผ่าน: เปลี่ยนรหัสผ่านสำเร็จ",
              forgetPassBannerDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 375 x 175 pixel)",
              noNotificationImageTitle: "[13.1] รูปภาพกรณีไม่มีแจ้งเตือน",
              noNotificationMessageTitle: "[13.2] ข้อความกรณีไม่มีแจ้งเตือน",
              noNotificationImageDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 226 x 226 pixel)",
              emptyPolicyImageTitle: "[14.1] รูปภาพกรณีไม่มีกรมธรรม์",
              emptyPolicyImageDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 226 x 226 pixel)",
              emptyPolicyMessageTitle: "[14.2] ข้อความกรณีไม่มีกรมธรรม์",
              maintenanceImageTitle: "[15.1] รูปภาพกรณีระบบปิดการใช้งาน",
              maintenanceImageDescription:
                "รูปภาพ .jpg, .svg ขนาดไฟล์ไม่เกิน 1 MB (แนะนำ 485 x 485 pixel)",
            },
          },
          workspace: {
            index: {
              title: "จัดการ Work Space",
              home: "หน้าแรก",
              addButton: "เพิ่ม WorkSpace",
              table: "จัดการ WorkSpace",
              deleteWorkspace: "ลบ WorkSpace",
              workspaceInfo: "ข้อมูล WorkSpace",
              cannotBeRestored: "จะถูกลบและไม่สามารถกู้คืนได้",
              cancel: "ปิดหน้าต่างนี้",
              delete: "ลบข้อมูล",
              notificationSuccess: "ทำรายการสำเร็จ",
              filters: {
                workspace: "WorkSpace",
                isActive: "สถานะ",
                statusAll: "ทั้งหมด",
                statusActive: "ใช้งาน",
                statusInactive: "ไม่ใช้งาน",
              },
              columns: {
                workspace: "WorkSpace",
                isActive: "สถานะ",
                description: "คำอธิบาย",
                updatedAt: "วันที่แก้ไขล่าสุด",
                statusValues: {
                  true: "ใช้งาน",
                  false: "ปิดใช้งาน",
                },
              },
              reset: "รีเซ็ต",
              filter: "กรอง",
            },
            new: {
              title: "เพิ่ม Work Space",
              title2: "จัดการ Work Space",
              home: "หน้าแรก",
              addButton: "เพิ่ม Work Space",
              header: "ข้อมูล Work Space",
              active: "ใช้งาน",
              name: "ชื่อ",
              description: "หมายเหตุ",
              cancel: "ยกเลิก",
              submit: "สร้าง",
              notificationSuccess: "ทำรายการสำเร็จ",
            },
            edit: {
              title: "แก้ไข Work Space",
              title2: "จัดการ Work Space",
              home: "หน้าแรก",
              addButton: "เพิ่ม Work Space",
              header: "ข้อมูล Work Space",
              active: "ใช้งาน",
              name: "ชื่อ",
              description: "หมายเหตุ",
              cancel: "ยกเลิก",
              submit: "บันทึก",
              notificationSuccess: "ทำรายการสำเร็จ",
            },
          },
          masterInsurancePlans: {
            detail: {
              index: {
                title: "แบบประกัน",
                breadcrumbs: {
                  home: "หน้าแรก",
                  masterInsurancePlanList: "เพิ่ม/ลด ข้อมูลแบบประกัน",
                },
              },
              DetailPage: {
                cancel: "ยกเลิก",
                save: "บันทึก",
              },
            },
            index: {
              addInsurancePlan: "เพิ่มแบบประกัน",
              addButton: "แบบประกัน",
              home: "หน้าหลัก",
              title: "เพิ่ม/ลด ข้อมูลแบบประกัน",
              all: "ทั้งหมด",
              list: "เพิ่ม/ลด ข้อมูลแบบประกัน",
              name: "ชื่อแบบประกัน",
              company: "บริษัทประกัน",
              type: "ประเภท",
              version: "เวอร์ชันที่ใช้",
              updatedAt: "วันที่แก้ไขล่าสุด",
              cancel: "ยกเลิก",
              confirm: "ยืนยัน",
              notInUse: "แบบร่าง",
              filter: {
                reset: "รีเซ็ต",
                filter: "กรอง",
              },
              modal: {
                form: "เลือกวิธีกรอกรายละเอียดแบบประกัน",
                freelance: {
                  title: "แยกตามฟิลด์แบบละเอียด ",
                  helperText: "การกรอกแบบใหม่ใช้สำหรับลูกค้า Freelance",
                },
                enterprise: {
                  title: "Markdown แบบรวมช่องเดียว",
                  helperText: "การกรอกแบบเดิมใช้สำหรับลูกค้า Enterprise",
                },
              },
              deleteTitle: "ลบแบบประกัน",
              deleteMessage:
                "ข้อมูลแบบประกัน <b>{{name}}</b> จะถูกลบและไม่สามารถกู้คืนได้",

              close: "ปิดหน้าต่างนี้",
              deleteInfo: "ลบข้อมูล",
              deleteSuccess: "ลบแบบประกันสำเร็จ",
              copy: "คัดลอก",
              publishedVersionEditModal: {
                title: "แก้ไข published version ที่ใช้",
                description:
                  "เลือกข้อมูลประกันสำหรับใช้แสดงที่ Application \n (ถ้าเลือกเป็นแบบร่างจะไม่แสดงประกันนี้ใน App)",
                fieldName: "เวอร์ชั่นที่ใช้งาน",
                confirm: "ยืนยัน",
                cancel: "ยกเลิก",
                error: "ไม่พร้อมใช้งาน",
                notInUse: "แบบร่าง",
                errorMessages:
                  "เนื่องจากยังกรอกข้อมูลบางส่วนไม่ครบถ้วน โปรดตรวจสอบข้อมูลดังต่อไปนี้",
                warningMessage: {
                  title:
                    "การแก้ไขจะส่งผลต่อแพ็กเกจประกันและรอบการลงทะเบียนที่เกี่ยวข้องกับแบบประกัน ดังนี้:",
                  1: {
                    header: "มีผลทันที",
                    description:
                      "เมื่อเปลี่ยนเวอร์ชันที่ใช้งานข้อมูลใหม่จะแสดงที่ Front Store ทันที",
                  },
                  2: {
                    header: "ไม่มีผลย้อนหลัง",
                    description:
                      "กับทุกคำสั่งซื้อและกรมธรรม์ที่เกิดขึ้นก่อนหน้า (หากต้องการอัปเดตแบบประกันที่ซื้้อสำเร็จไปแล้วให้เป็นเวอร์ชันล่าสุด กรุณาแก้ไขข้อมูลที่เมนูกรมธรรม์ทีละรายการ)",
                  },
                },
              },
              createNewVersionTitle: "สร้างเวอร์ชั่นใหม่",
              createNewVersionMessage:
                "เนื่องจากข้อมูลเวอร์ชันที่ต้องการแก้ไขถูกใช้งานอยู่ใน Application \n ระบบจะสร้างข้อมูลเวอร์ชันถัดไปสำหรับการแก้ไขให้อัตโนมัติ",
              noVersionOptions:
                "ไม่มีข้อมูลเวอร์ชั่นอื่นให้เลือก กรุณากดแก้ไขเพื่อสร้างเวอร์ชั่นใหม่",
              publishSuccess: "ทำรายการสำเร็จ",
            },
            components: {
              duplicateModal: {
                title: "คัดลอกแบบประกัน",
                content: "ระบบจะคัดลอกแบบประกัน",
                content2:
                  "มาสร้างเป็นต้นแบบของแบบประกันใหมกรุณาตรวจสอบรายละเอียด",
                duplicateName: "ชื่อแบบประกัน",
                insuranceType: "ประเภท",
                insuranceCompany: "บริษัทประกัน",
                confirm: "คัดลอกแบบประกัน",
                cancel: "ยกเลิก",
                duplicateSuccess: "ทำรายการสำเร็จ",
                copy: "คัดลอก",
              },
              freelance: {
                CustomPackage: {
                  info: "ตัวเลขสำหรับ Slider",
                  budget: "จำนวนเงิน (บาท)",
                  critical_illness_benefit: "ความคุ้มครองโรคร้ายแรง",
                  ipd_benefit: "ค่ารักษาผู้ป่วยใน (IPD)",
                  opd_benefit: "ความคุ้มครอง OPD",
                  opd_plus_benefit: "ค่ารักษาผู้ป่วยนอก (OPD+)",
                  ad_and_benefit: "วงเงินคุ้มครองชีวิต/อุบัติเหตุ (AD&D)",
                  annuity_5_benefit: "บำนาญ",
                  annuity_10_benefit: "บำนาญ",
                  annuity_to_60_benefit: "บำนาญ",
                  annuity_benefit: "บำนาญ",
                  amount: "จำนวน",
                  description: "รายละเอียด",
                  sum_insured: "จำนวนประกัน",
                  pass_away_by_accident: "เสียชีวิตจากอุบัติเหตุ",
                  save: "บันทึก",
                  cancel: "ยกเลิก",
                  success: "ทำรายการสำเร็จ",
                  insuranceDescription: "คำอธิบายประกัน",
                  insuranceBenefitDetail: "รายละเอียดผลประโยชน์ประกัน",
                  publishCondition: {
                    title:
                      "เงื่อนไขในการ Publish แบบประกันคือ ต้องกรอกข้อมูลต่อไปนี้ให้ครบถ้วน",
                    benefitDetailBullet:
                      "ช่องรายละเอียดผลประโยชน์ประกัน ใน Section คำอธิบายประกัน",
                    amountBullet:
                      "ช่องจำนวนเงิน (บาท) และรายละเอียดใน Section ตัวเลขสำหรับ Slider",
                  },
                },
                CompensationTable: {
                  save: "บันทึก",
                  cancel: "ยกเลิก",
                  success: "ทำรายการสำเร็จ",
                  age: "อายุ",
                  class1: "ขั้นอาชีพ 1",
                  class2: "ขั้นอาชีพ 2",
                  class3: "ขั้นอาชีพ 3",
                  class4: "ขั้นอาชีพ 4",
                  male: "ชาย",
                  female: "หญิง",
                  readOnlyAlert:
                    "เซลล์นี้เป็นข้อมูลอ่านอย่างเดียว ไม่สามารถแก้ไขได้",
                  readOnlyAlertTitle: "ไม่สามารถแก้ไขได้",
                  validationErrorTitle: "เกิดข้อผิดพลาด",
                  validationErrorAlert:
                    "ไม่สามารถบันทึกข้อมูลได้เนื่องจากมีอักขระที่ไม่ใช้ตัวเลขปนอยู่ กรุณาตรวจสอบข้อมูลอีกครั้ง",
                  validationErrorRetry: "กลับไปแก้ไข",
                  validationErrorCancel: "ยกเลิก",
                  publishCondition:
                    "เงื่อนไขในการ Publish แบบประกันคือ ต้องมีเบี้ยประกันอย่างน้อย 1 ช่องในตารางกรมธรรม์",
                },
                RiderConfigSection: {
                  cancel: "ยกเลิก",
                  save: "บันทึก",
                  notificationSuccess: "ทำรายการสำเร็จ",
                },
                RiderConfigList: {
                  additionalContract: "สัญญาเพิ่มเติม",
                  description:
                    "ระบุประกันแบบสัญญาเพิ่มเติมที่ผูกกับประกันนี้ (เงื่อนไขคือต้องซื้อประกันนี้ก่อนจึงจะซื้อประกันที่เป็นสัญญาเพิ่มเติมได้)",
                  addItem: "เพิ่มรายการ",
                  item: "รายการที่ {{index}}",
                  insuranceCompany: "บริษัทประกัน",
                  insuranceType: "ประเภท",
                  insuranceName: "ชื่อแบบประกัน",
                  title: "ลบสัญญาเพิ่มเติม",
                  deleteDescription: "ต้องการลบสัญญาเพิ่มเติมนี้ใช่หรือไม่",
                  cancel: "ยกเลิก",
                },
                SettingCondition: {
                  salesCriteria: {
                    title: "เกณฑ์การขาย",
                    description: "ประกันนี้เป็นสัญญาเพิ่มเติม (Rider)",
                    caption:
                      "กรณีเป็นสัญญาเพิ่มเติม (มีประเภทประกันที่ต้องซื้อก่อนหน้า) ไม่ต้องระบุข้อตกลงและคำถามก่อนซื้อ",
                    condition: {
                      title: "ถ้าเป็นสัญญาเพิ่มเติม",
                      1: "ต้องระบุประเภทของแบบประกันที่ต้องซื้อก่อนหน้า เช่น ต้องซื้อประกันอุบัติเหตุก่อนถึงจะซื้อประกันนี้ได้ เป็นต้น",
                      2: "ประกันที่ซื้อก่อนหน้าต้องเป็นของบริษัทประกันเดียวกันเท่านั้น",
                      3: "ต้องซื้ออยู่ในคำสั่งซื้อหรือแพ็กเกจเดียวกัน",
                      4: "ประกันที่เป็นสัญญาเพิ่มเติมจะใช้คำถามสุขภาพชุดเดียวกับประกันหลัก",
                    },
                  },
                  cancel: "ยกเลิก",
                  save: "บันทึก",
                  mainInsurance: {
                    title: "ประกันหลัก",
                    caption:
                      "ระบุรายชื่อแบบประกันหลักที่ต้องซื้อก่อนหน้าแบบประกันนี้",
                    chooseButton: "เลือกแบบประกัน",
                    name: "ชื่อแบบประกัน",
                    type: "ประเภท",
                    noInsuranceFound: "ไม่พบแบบประกัน",
                    AddMainInsuranceModal: {
                      title: "เลือกประกันหลัก",
                      name: "ชื่อแบบประกัน",
                      type: "ประเภท",
                      cancel: "ยกเลิก",
                      choose: "เลือก",
                      notificationSuccess: "ทำรายการสำเร็จ",
                      noInsuranceFound: "ไม่พบแบบประกัน",
                    },
                  },
                  termsAndConditions: {
                    header: "ข้อตกลงและเงื่อนไข",
                    statement: "คำชี้แจงก่อนเงื่อนไข",
                    title: "หัวข้อ",
                    detail: "รายละเอียด",
                  },
                  question: {
                    title: "คำถามก่อนซื้อประกัน",
                    chooseButton: "เลือกคำถาม",
                    noQuestionsFound: "ไม่พบคำถาม",
                    question: "คำถาม",
                    AddQuestionModal: {
                      title: "คำถาม",
                      noQuestionsFound: "ไม่พบคำถาม",
                      cancel: "ยกเลิก",
                      choose: "เลือก",
                      notificationSuccess: "ทำรายการสำเร็จ",
                    },
                  },
                  close: "ปิดหน้าต่างนี้",
                  deleteQuestion: "ลบคำถาม",
                  cannotBeRestored: "จะถูกลบออกจากชุดคำถามนี้",
                  notificationSuccess: "ทำรายการสำเร็จ",
                  deleteMainInsurance: "ลบประกันหลัก",
                  wantToDeleteMainInsurance: "ต้องการลบประกันหลัก",
                  orNot: "หรือไม่",
                  publishCondition: {
                    title:
                      "เงื่อนไขในการ Publish แบบประกันคือ ต้องกรอกข้อมูลต่อไปนี้ให้ครบถ้วน",
                    nonRiderBullet:
                      "ถ้าไม่ได้เป็นสัญญาเพิ่มเติม ต้องระบุข้อตกลงและเงื่อนไขและต้องมีคำถามก่อนซื้อประกันอย่างน้อย 1 ข้อ",
                    riderBullet:
                      "ถ้าเป็นสัญญาเพิ่มเติม ต้องมีประกันหลักอย่างน้อย 1 แบบประกัน",
                  },
                },
              },
              FreelanceForm: {
                saving: "กำลังบันทึก...",
                tab1: "รายละเอียดแบบประกัน",
                tab2: "ข้อมูลสำหรับ Custom package เอง",
                tab3: "ตารางกรมธรรม์",
                tab4: "การตั้งค่าเงื่อนไข",
                cancel: "ยกเลิก",
                save: "บันทึก",
                updatedAt: "แก้ไขล่าสุด",
                version: "เวอร์ชัน",
                usingVersion: "เวอร์ชันที่ใช้งาน",
                enrollmentUsing: "Enrollment ที่ใช้งานชุดประกันเวอร์ชันนี้:",
                versionDisplayOnApp: "เวอร์ชันปัจจุบันที่ใช้แสดงอยู่ที่ App",
                saveSuccess: "ทำรายการสำเร็จ",
                detail: {
                  info: "รายละเอียดแบบประกัน",
                  companyName: "บริษัทประกัน",
                  insuranceName: "ชื่อแบบประกัน",
                  remark: "หมายเหตุ",
                  active: "ใช้งาน",
                  addItem: "เพิ่มรายการ",
                  order: "รายการที่",
                  orderName: "ชื่อรายการ",
                  detail: "รายละเอียด",
                  summaryTable: "ตารางสรุป",
                  listOfBenefits: "รายการผลประโยชน์",
                  compensationList: "รายการค่าชดเชย",
                  insurancePlanDetail: "รายละเอียดแผนประกัน",
                  summaryBenefit: "สรุปผลประโยชน์",
                  policyAndConditions: "เงื่อนไขกรมธรรม์",
                  termsAndBenefits: "ข้อกำหนดและผลประโยชน์",
                  documentRequirementsAndBenefits:
                    "เอกสารข้อกำหนดและผลประโยชน์",
                  policyInformation:
                    "ข้อมูลกรมธรรม์ (สำหรับแสดงในกรมธรรม์ของฉัน)",
                  acceptPdf: "รองรับไฟล์ .pdf",
                  browseFile: "แนบไฟล์",
                  insuranceType: "ประเภท",
                  shortDescription:
                    "รายละเอียดแบบย่อ (ใช้สำหรับประกันที่กดลิงก์จากเว็บภายนอก)",
                  showInPackage:
                    "แสดงในรายละเอียดแพ็กเกจ (เลือกได้ 1 รายการจากตารางทั้งหมด)",
                },
                publishCondition: {
                  title:
                    "เงื่อนไขในการ Publish แบบประกันคือ <b>ถ้ามีการเปิดใช้งาน Section เหล่านี้ต้องกรอกข้อมูลทุกช่องใน Section ให้ครบถ้วน</b>",
                  infoBullet: "รายละเอียดแผนประกัน",
                },
                infoCustomPackage: {
                  info: "ค่าที่ใช้สำหรับเลือกแบบประกัน",
                  accident: {
                    byAccident: "เสียชีวิตจากอุบัติเหตุ",
                    insuranceMoney: "เงินเอาประกันภัย",
                  },
                  health: {
                    ipd: "ค่ารักษาผู้ป่วยใน (IPD)",
                    opd: "โอพีดี พลัส+ (OPD+)",
                  },
                  annuity: {
                    ipd: "ค่ารักษาผู้ป่วยใน (IPD)",
                  },
                  amount: "จำนวน",
                  detail: "รายละเอียด",
                },
                compensationTable: {
                  info: "Insurance premium",
                },
              },
              VersionControl: {
                version: "เวอร์ชัน",
                usingVersion: "เวอร์ชันที่ใช้งาน",
                enrollmentUsing: "Enrollment ที่ใช้งานชุดประกันเวอร์ชันนี้:",
                versionDisplayOnApp: "เวอร์ชันปัจจุบันที่ใช้แสดงอยู่ที่ App",
                updatedAt: "แก้ไขล่าสุด {{updatedAt}}",
                validateThisVersion: "ตรวจสอบ",
                validateThisVersionDescription:
                  "สำหรับเช็คว่าแบบประกันเวอร์ชันนี้มีข้อมูลพร้อมใช้ที่ Application หรือไม่ (ต้องบันทึกข้อมูลที่แก้ไขล่าสุดก่อนกดตรวจสอบ)",
                result: "ผลการตรวจสอบ",
                errorMessages:
                  "เนื่องจากยังกรอกข้อมูลบางส่วนไม่ครบถ้วน โปรดตรวจสอบข้อมูลดังต่อไปนี้",
                readyToPublish: "เวอร์ชัน {{versionName}} พร้อมใช้งาน",
                notReadyToPublish: "เวอร์ชัน {{versionName}} ไม่พร้อมใช้งาน",
                close: "ปิดหน้าต่างนี้",
              },
              EnterpriseForm: {
                name: "ชื่อแบบประกัน",
                info: "รายละเอียดแบบประกัน",
                nameTh: "ชื่อแบบประกัน (TH)",
                nameEn: "ชื่อแบบประกัน (EN)",
                premium: "เบี้ยประกัน (บาท)",
                remark: "หมายเหตุ",
                remarkTh: "หมายเหตุ (TH)",
                remarkEn: "หมายเหตุ (EN)",
                save: "บันทึก",
                cancel: "ยกเลิก",
                breadcrumbs: {
                  home: "หน้าแรก",
                  insurance: "จัดการชุดแบบประกัน",
                  insuranceDetail: "ชุดแบบประกันปี {{year}}",
                  ipdTitle: "แบบประกัน IPD",
                  opdTitle: "แบบประกัน OPD",
                  dentalTitle: "แบบประกัน Dental",
                },
                success: "ทำรายการสำเร็จ",
                coverageLevel: "ระดับความคุ้มครอง",
                coverageLevelHelper:
                  "*เพื่อให้ตรงตามวัตถุประสงค์ของสวัสดิการพนักงาน ถ้ามีการเลือกประกันให้ครอบครัวระบบจะคัดกรองเฉพาะแบบประกันครอบครัวที่ระดับต่ำกว่าหรือเท่ากับระดับความคุ้มครองที่เลือกให้ตัวพนักงานเองไปแสดงเท่านั้น",
                insuranceFor: "ประกันสำหรับ",
                insuranceType: "ประเภทประกัน",
                insuranceForOptions: {
                  employee: "พนักงาน",
                  family: "ครอบครัว",
                },
                addInsurance: "เพิ่มแบบประกัน",
                FilterTableWithQueryParams: {
                  confirm: "กรอง",
                  reset: "รีเซ็ต",
                },
              },
            },
            customPackageFields: {
              description:
                "ระบุเป็นตัวเลขเท่านั้นเพื่อกำหนดจำนวนเงินแสดงใน Slider ในการเลือกแผน",
            },
          },
          paymentTransaction: {
            index: {
              home: "หน้าแรก",
              title: "การชำระเงิน",
              filter: {
                input: {
                  employeeName: "รหัสอ้างอิง, ผู้ชำระเงิน",
                  masterInsuranceId: "ชุดแบบประกัน",
                  enrollmentId: "รอบลงทะเบียน",
                  status: "สถานะ",
                  startPaymentDate: "วันที่ชำระตั้งแต่",
                  endPaymentDate: "ถึงวันที่",
                  paymentMethod: "วิธีจ่ายเงิน",
                  paymentType: "ประเภทการจ่ายเงิน",
                },
                status: {
                  all: "ทั้งหมด",
                  [PaymentTransactionStatusEnum.PENDING]: "รอการชำระเงิน",
                  [PaymentTransactionStatusEnum.SUCCESS]: "สำเร็จ",
                  [PaymentTransactionStatusEnum.FAILED]: "ไม่สำเร็จ",
                },
                paymentMethodEnum: {
                  all: "ทั้งหมด",
                  [EnumPaymentMethod.BANK_TRANSFER]: "โอนผ่านธนาคาร",
                  [EnumPaymentMethod.CREDIT_CARD]: "บัตรเครดิต",
                  [EnumPaymentMethod.QR_PROMPTPAY]: "QR Promptpay",
                  [EnumPaymentMethod.MONTHLY_CREDIT_CARD]:
                    "ตัดชำระรายเดือนบัตรเครดิต",
                  [EnumPaymentMethod.MONTHLY_BANK_KBANK]:
                    "ตัดชำระรายเดือนผ่านธนาคารกสิกรไทย",
                  [EnumPaymentMethod.MONTHLY_BANK_KTB]:
                    "ตัดชำระรายเดือนผ่านธนาคารกรุงไทย",
                  [EnumPaymentMethod.MONTHLY_BANK_SCB]:
                    "ตัดชำระรายเดือนผ่านธนาคารไทยพาณิชย์",
                },
                paymentCategoryEnum: {
                  all: "ทั้งหมด",
                  [PaymentCategoryEnum.PAY_INSURANCE_PREMIUM]:
                    "ชำระเบี้ยประกัน",
                },
              },
              button: {
                reset: "รีเซ็ต",
                filter: "กรอง",
              },
              table: {
                employeeName: "ผู้ชำระเงิน",
                insurancePlan: "ชุดแบบประกัน",
                enrollmentName: "รอบลงทะเบียน",
                agreementInstallmentNumber: "งวดที่",
                masterInsuranceName: "ชุดแบบประกัน",
                amount: "ยอดชำระ (บาท)",
                status: "สถานะ",
                paymentDate: "วันที่ชำระ",
                updatedAt: "วันที่แก้ไขล่าสุด",
                transactionRef: "รหัสอ้างอิง",
                paymentMethod: "วิธีจ่ายเงิน",
                paymentType: "ประเภทการจ่ายเงิน",
              },
              export: "ออกรายงาน",
            },
            detail: {
              home: "หน้าแรก",
              title: "การชำระเงิน",
              insuranceTransactionInfo: {
                title: "ข้อมูลการรับเงิน",
                gatewayRefId: "รหัสอ้างอิง",
                ownerName: "ผู้ชำระเงิน",
                paymentType: "วิธีการตัดรอบ",
                paymentInstallment: "งวดการชำระ",
                paymentMethod: "วิธีจ่ายเงิน",
                amount: "ยอดชำระ",
                status: "สถานะ",
                paymentDate: "วันที่ชำระ",
                paymentMethodEnum: {
                  all: "ทั้งหมด",
                  [EnumPaymentMethod.BANK_TRANSFER]: "โอนผ่านธนาคาร",
                  [EnumPaymentMethod.CREDIT_CARD]: "บัตรเครดิต",
                  [EnumPaymentMethod.QR_PROMPTPAY]: "QR Promptpay",
                  [EnumPaymentMethod.MONTHLY_CREDIT_CARD]:
                    "ตัดชำระรายเดือนบัตรเครดิต",
                  [EnumPaymentMethod.MONTHLY_BANK_KBANK]:
                    "ตัดชำระรายเดือนผ่านธนาคารกสิกรไทย",
                  [EnumPaymentMethod.MONTHLY_BANK_KTB]:
                    "ตัดชำระรายเดือนผ่านธนาคารกรุงไทย",
                  [EnumPaymentMethod.MONTHLY_BANK_SCB]:
                    "ตัดชำระรายเดือนผ่านธนาคารไทยพาณิชย์",
                },
                statusEnum: {
                  [PaymentTransactionStatusEnum.PENDING]: "รอการชำระเงิน",
                  [PaymentTransactionStatusEnum.SUCCESS]: "สำเร็จ",
                  [PaymentTransactionStatusEnum.FAILED]: "ไม่สำเร็จ",
                },
                baht: "{{amount}} บาท",
                relation: "ความสัมพันธ์ของผู้ชำระเบี้ยประกันภัย",
                relationEnum: {
                  self: "ตนเอง",
                  [EnumRelationship.Father]: "บิดา",
                  [EnumRelationship.Mother]: "มารดา",
                  [EnumRelationship.Child]: "บุตร",
                  [EnumRelationship.Spouse]: "คู่สมรส (กรณีจดทะเบียนสมรส)",
                  [EnumRelationship.LifePartner]:
                    "คู่ชีวิต (กรณีไม่จดทะเบียนสมรส)",
                },
                remark: "เนื่องจาก",
                paymentTypeEnum: {
                  [EnumPaymentScheduleMethod.INSTALLMENT]:
                    "ตัดรอบอัตโนมัติ / Subscription",
                  [EnumPaymentScheduleMethod.PAY_BY_SELF]: "ชำระด้วยตนเอง",
                },
                paymentInstallmentEnum: {
                  monthly: "รายเดือน",
                },
              },
              paymentTransactionInfo: {
                title: "ข้อมูลการจ่ายเงิน",
                agreementInstallmentNumber: "งวดที่",
                installmentPaymentAmount: "ยอดชำระต่องวด (บาท)",
                status: "สถานะ",
                paymentMethod: "ช่องทางการชำระเงิน",
                installmentPaymentDate: "วันที่ชำระ",
                updatedAt: "วันที่แก้ไขล่าสุด",
                periodNo: "ยอดชำระต่องวด (บาท)",
                paymentType: "ช่องทางการชำระเงิน",
                paymentDate: "วันที่ชำระ",
                insuranceInfo: {
                  title: "ชื่อประกัน",
                  companyName: "บริษัทประกัน",
                  paymentAmountPerPeriod: "ยอดชำระต่องวด (บาท)",
                },
                statusEnum: {
                  [PaymentTransactionStatusEnum.PENDING]: "รอการชำระเงิน",
                  [PaymentTransactionStatusEnum.SUCCESS]: "สำเร็จ",
                  [PaymentTransactionStatusEnum.FAILED]: "ไม่สำเร็จ",
                },
                paymentMethodEnum: {
                  // [EnumPaymentMethod.BANK_TRANSFER]: "โอนผ่านธนาคาร",
                  [EnumPaymentMethod.CREDIT_CARD]: "บัตรเครดิต",
                  // [EnumPaymentMethod.DEBIT_CARD]: "บัตรเดบิต",
                  [EnumPaymentMethod.QR_PROMPTPAY]: "QR Promptpay",
                  [EnumPaymentMethod.MONTHLY_CREDIT_CARD]:
                    "ตัดชำระรายเดือนบัตรเครดิต",
                  [EnumPaymentMethod.MONTHLY_BANK_KBANK]:
                    "ตัดชำระรายเดือนผ่านธนาคารกสิกรไทย",
                  [EnumPaymentMethod.MONTHLY_BANK_KTB]:
                    "ตัดชำระรายเดือนผ่านธนาคารกรุงไทย",
                  [EnumPaymentMethod.MONTHLY_BANK_SCB]:
                    "ตัดชำระรายเดือนผ่านธนาคารไทยพาณิชย์",
                },
                paymentCategoryEnum: {
                  all: "ทั้งหมด",
                  [PaymentCategoryEnum.PAY_INSURANCE_PREMIUM]:
                    "ชำระเบี้ยประกัน",
                },
              },
              masterInsurancePlans: {
                name: "ชื่อประกัน",
                companyName: "บริษัทประกัน",
                amount: "ยอดชำระต่องวด (บาท)",
              },
              back: "ย้อนกลับ",
              baht: "บาท",
              broker: "Broker:",
            },
          },
          insuranceTransaction: {
            components: {
              changeVersionInsuranceModal: {
                title: "เปลี่ยนเวอร์ชันแต่ละประกัน",
                description:
                  "สามารถกรองตัวเลือกที่ต้องการเปลี่ยนเวอร์ชันเพื่อความสะดวกในใช้งาน",
                description2:
                  "ตัวเลือกเวอร์ชันของประกันจะแสดงแค่รายการที่มีข้อมูลครบถ้วนเท่านั้นไม่รวมเวอร์ชันที่เป็นแบบร่าง",
                usingVersion: "เวอร์ชันที่ใช้งาน",
                version: "เวอร์ชัน: {{version}}",
                cancel: "ยกเลิก",
                ok: "ยืนยัน",
                helperText: "เวอร์ชันปัจจุบันที่ใช้แสดงอยู่ที่ App",
                success: "ทำรายการสำเร็จ",
              },
              confirmToChangeVersionModal: {
                title: "ต้องการเปลี่ยนเวอร์ชัน",
                description:
                  "หากเปลี่ยนเวอร์ชันจะส่งผลต่อรายละเอียดกรมธรรม์ ของแต่ละประกัน",
                close: "ปิดหน้าต่างนี้",
                changeVersion: "เปลี่ยนเวอร์ชัน",
              },
            },
            index: {
              home: "หน้าแรก",
              title: "สถานะกรมธรรม์",
              header: "สถานะกรมธรรม์",
              filter: {
                name: "ชื่อผู้เอาประกัน, เลขกรมธรรม์",
                insurance: "ชื่อกรมธรรม์",
                insuranceCompany: "บริษัทประกัน",
                version: "เวอร์ชัน",
                startBuyDate: "วันที่ซื้อตั้งแต่",
                endBuyDate: "ถึงวันที่",
                updatedAt: "แก้ไขล่าสุด",
                status: "สถานะ",
                requestId: "เลขที่ใบคำขอ-กลุ่ม",
                buyDate: "วันที่ซื้อ",
              },

              table: {
                name: "ชื่อผู้เอาประกัน",
                insurance: "ชื่อกรมธรรม์",
                insuranceCompany: "บริษัทประกัน",
                version: "เวอร์ชัน",
                policyNumber: "เลขกรมธรรม์",
                requestId: "เลขที่ใบคำขอ-กลุ่ม",
                buyDate: "วันที่ซื้อ",
                updatedAt: "แก้ไขล่าสุด",
                status: "สถานะ",
                isMain: "หลัก",
              },
              changeVersion: "เปลี่ยนเวอร์ชันประกัน",
              status: {
                all: "ทั้งหมด",
              },
              EditStatusModal: {
                title: "ปรับสถานะแบบประกัน",
                cancel: "ยกเลิก",
                confirm: "ยืนยัน",
                state: "สถานะแบบประกัน",
                of: "ของ",
              },
            },
            edit: {
              modal: {
                title: "ต้องการเปลี่ยนเวอร์ชัน",
                title2: "เปลี่ยนเวอร์ชันแต่ละประกัน",
                description:
                  "หากเปลี่ยนเวอร์ชันจะส่งผลต่อรายละเอียดกรมธรรม์ ของแต่ละประกัน",
                description2:
                  "สามารถกรองตัวเลือกที่ต้องการเปลี่ยนเวอร์ชันเพื่อความสะดวกในการใช้งาน",
                close: "ปิดหน้าต่างนี้",
                next: "เปลี่ยนเวอร์ชัน",
                version: "เวอร์ชัน: {{version}}",
                usingVersion: "เวอร์ชันที่ใช้งาน",
                cancel: "ยกเลิก",
                ok: "ยืนยัน",
                latest: "ล่าสุด",
                helperText: "เวอร์ชันปัจจุบันที่ใช้แสดงอยู่ที่ App",
              },
            },
            detail: {
              home: "หน้าแรก",
              rootPath: "กรมธรรม์",
              header: "ข้อมูลกรมธรรม์",
              insuranceInfo: {
                title: "ข้อมูลประกัน",
              },
              currentVersion: "ล่าสุด",
              notificationSuccess: "ทำรายการสำเร็จ",
              form: {
                name: "ชื่อผู้เอาประกัน",
                enrollmentName: "รอบลงทะเบียน",
                insurance: "ชื่อกรมธรรม์",
                insuranceCompany: "บริษัทประกัน",
                insuranceType: "ประเภท",
                premiumPerMonth: "ค่าเบี้ยประกันต่อเดือน (บาท)",
                usingVersion: "เวอร์ชันที่ใช้งาน",
                buyDate: "วันที่ซื้อ",
                expireDate: "วันหมดอายุ",
                registerPurchase: "การลงทะเบียนที่ซื้อ",
                updatedAt: "แก้ไขล่าสุด",
                back: "ย้อนกลับ",
                viewInsuranceDetailPage: "ดูหน้ารายละเอียดประกัน",
                viewPolicyPage: "ดูหน้ากรมธรรม์ของฉัน",
                helperText: "เวอร์ชันปัจจุบันที่ใช้แสดงอยู่ที่ App",
                status: "สถานะกรมธรรม์",
                applicationNumber: "เลขที่ใบคำขอ",
                save: "บันทึก",
                policyNumber: "เลขที่กรมธรรม์",
                startContractDate: "วันที่ขอกรมธรรม์ประกันภัย",
                applicationDate: "วันที่ทำสัญญาประกันภัย",
                endContractDate: "วันครบกำหนดสัญญาประกันภัย",
                insuranceCompanyReceivedDate:
                  "วันที่บริษัทได้รับกรมธรรม์ประกันภัย (Freelook)",
                group: "กลุ่ม",
                isMain: "เป็นประกันหลัก",
                isMainText: {
                  yes: "ใช่",
                  no: "ไม่ใช่",
                },
              },
              confirmChangeVersion: {
                title: "ต้องการเปลี่ยนเวอร์ชัน",
                description:
                  "เปลี่ยนเวอร์ชันจาก {{currentVersion}} เป็นเวอร์ชัน {{newVersion}} หากเปลี่ยนเวอร์ชันจะส่งผลต่อรายละเอียดกรมธรรม์",
                beforeChange:
                  "สามารถดูข้อมูลเวอร์ชัน {{newVersion}} ได้ก่อนเปลี่ยนจริง",
                viewInsuranceDetailPage: "ดูหน้ารายละเอียดประกัน",
                viewPolicyPage: "ดูหน้ากรมธรรม์ของฉัน",
                ok: "เปลี่ยนเวอร์ชัน",
                cancel: "ปิดหน้าต่างนี้",
              },
              modal: {
                title: "ต้องการเปลี่ยนเวอร์ชันหรือไม่",
                description:
                  "เปลี่ยนเวอร์ชันจาก {{from}} เป็นเวอร์ชัน {{to}} การเปลี่ยนเวอร์ชันจะมีผลกับรายละเอียดกรมธรรม์",
                beforeChange:
                  "คุณสามารถดูรายละเอียดเวอร์ชัน {{to}} ก่อนเปลี่ยนจริงได้",
                viewInsuranceDetailPage: "ดูหน้ารายละเอียดแบบประกัน",
                viewPolicyPage: "ดูหน้ากรมธรรม์ของฉัน",
              },
              policyInfo: "ข้อมูลกรมธรรม์เพิ่มเติม (สามารถแก้ไขได้)",
              paymentInfo: "ข้อมูลการชำระเงิน",
              installments: "งวดการชำระเงิน",
              cutOffMethod: "วิธีการตัดรอบ",
              installment: "งวดการชำระ",
              paymentMethods: "ช่องทางการจ่ายเงิน",
              totalPremium: "เบี้ยประกันรวม",
              alreadyPaid: "เบี้ยที่จ่ายแล้ว",
              installmentsAlreadyPaid: "จำนวนงวดที่จ่ายแล้ว",
              baht: "{{amount}} บาท",
              table: {
                installment: "งวดที่",
                year: "ปีที่",
                amount: "ยอดที่ต้องชำระ",
                status: "สถานะ",
                dueDate: "วันครบกำหนดชำระ",
                paymentDate: "วันที่ชำระเงิน",
                paymentId: "Payment ID",
                agreementInstallmentStatus: {
                  PENDING: "รอชำระเงิน",
                  PAID: "ชำระเงินแล้ว",
                  OVERDUE: "ค้างชำระ",
                },
              },
              paymentType: {
                INSTALLMENT: "รายเดือน",
              },
              InstallmentDetail: {
                home: "หน้าแรก",
                title: "กรมธรรม์",
                installment: "งวดที่ {{number}}",
                insuranceInfo: "ข้อมูลกรมธรรม์",
                paymentInfo: "ข้อมูลการชำระเงิน",
                back: "ย้อนกลับ",
                policyName: "ชื่อกรมธรรม์",
                type: "ประเภท",
                insuranceCompany: "บริษัทประกัน",
                insured: "ชื่อผู้เอาประกัน",
                applicationNumber: "เลขที่ใบคำขอ",
                agreementInfo: {
                  installment: "งวดที่",
                  year: "ปีที่",
                  amount: "ยอดที่ต้องชำระ",
                  status: "สถานะ",
                  dueDate: "วันครบกำหนดชำระ",
                  paymentDate: "วันที่ชำระเงิน",
                  paymentId: "Payment ID",
                  agreementInstallmentStatus: {
                    PENDING: "รอชำระเงิน",
                    PAID: "ชำระเงินแล้ว",
                    OVERDUE: "ค้างชำระ",
                  },
                  baht: "{{amount}} บาท",
                },
              },
              paymentTypeEnum: {
                [EnumPaymentScheduleMethod.INSTALLMENT]:
                  "ตัดรอบอัตโนมัติ / Subscription",
                [EnumPaymentScheduleMethod.PAY_BY_SELF]: "ชำระด้วยตนเอง",
              },
              paymentMethod: {
                [EnumPaymentMethod.CREDIT_CARD]: "บัตรเครดิต",
                [EnumPaymentMethod.BANK_TRANSFER]: "โอนเงินผ่านธนาคาร",
                [EnumPaymentMethod.QR_PROMPTPAY]: "QR Promptpay",
                [EnumPaymentMethod.MONTHLY_CREDIT_CARD]: "บัตรเครดิต",
              },
            },
          },
          overdueTransaction: {
            index: {
              title: "รายการค้างชำระ",
              home: "หน้าแรก",
              filter: {
                title: "ตัวกรอง",
                ownerNameOrPolicyNumber: "ชื่อเจ้าของกรรมธรรม์, เลขกรรมธรรม์",
                insuranceCompany: "บริษัทประกัน",
                contactStatus: "สถานะการติดต่อ",
                reset: "รีเซ็ต",
                filter: "กรอง",
              },
              table: {
                contacted: "ติดต่อแล้ว",
                ownerName: "ชื่อเจ้าของกรรมธรรม์",
                company: "บริษัท",
                policyNumber: "เลขกรรมธรรม์",
                amount: "จำนวนเงิน",
                dueDate: "วันครบกำหนด",
                overdueDays: "ค้างชำระ (วัน)",
              },
              contactStatus: {
                all: "ทั้งหมด",
                contacted: "ติดต่อแล้ว",
                notContacted: "ยังไม่ได้ติดต่อ",
              },
              confirmModal: {
                title: "ปรับสถานะรายการ",
                body:
                  "ต้องการปรับสถานะรายการของ  <b>{{name}}</b> - <b>เลขกรมธรรม์ {{policyNumber}}</b> เป็น <b>{{status}}</b> หรือไม่",
                cancel: "ยกเลิก",
                confirm: "ยืนยัน",
              },
              detailModal: {
                title: "รายละเอียดรายการ",
                ownerName: "ชื่อเจ้าของกรรมธรรม์",
                company: "บริษัท",
                planName: "ชื่อแบบประกัน",
                type: "ประเภท",
                amount: "จำนวนเงิน",
                dueDate: "วันครบกำหนด",
                overdueDays: "ค้างชำระ",
                lapseRemainingDays: "ไม่มีผลบังคับใช้อีก",
                days: "วัน",
                phone: "เบอร์โทรศัพท์",
                email: "อีเมล",
                currentAddress: "ที่อยู่ปัจจุบัน",
                registrationAddress: "ที่อยู่ตามทะเบียนบ้าน",
                workAddress: "ที่อยู่ที่ทำงาน",
                policiesTitle: "ข้อมูลกรรมธรรม์",
                policiesSubtitle: "(แบบประกันทั้งหมดที่อยู่ในแพ็กเกจ)",
                baht: "บาท",
                viewDetail: "ดูรายละเอียด >",
                close: "ปิดหน้าต่างนี้",
                markContacted: "บันทึกว่าติดต่อแล้ว",
              },
              notificationSuccess: "ทำรายการสำเร็จ",
            },
          },
          lead: {
            index: {
              title: "Log ค้นหาประกัน",
              home: "หน้าแรก",
              export: "ออกรายงาน",
              reset: "รีเซ็ต",
              filter: "กรอง",
              name: "ชื่อแบบประกัน",
              type: "ประเภท",
              insuranceCompany: "บริษัทประกัน",
              start: "วันที่ส่งคำขอตั้งแต่",
              end: "ถึงวันที่",
              status: "สถานะ",
              insurance: "แบบประกัน",
              phoneNumber: "เบอร์ติดต่อกลับ",
              info: "ข้อมูล",
              coverage: "ความคุ้มครอง",
              sendDate: "วันเวลาที่ส่ง",
              contacted: "ติดต่อแล้ว",
              Male: "ชาย",
              Female: "หญิง",
              all: "ทั้งหมด",
              columnStatus: {
                all: "ทั้งหมด",
                contacted: "ติดต่อแล้ว",
                nonContacted: "ยังไม่ติดต่อ",
              },
              phoneNumberOptions: {
                all: "แสดงทั้งมีและไม่มีเบอร์",
                have: "มีเบอร์ติดต่อ",
                no: "ไม่มีเบอร์",
              },
              notificationSuccess: "ทำรายการสำเร็จ",
              adjustStatus: "ปรับสถานะรายการ",
              cancel: "ยกเลิก",
              confirm: "ยืนยัน",
              updateDescription: "ต้องการปรับสถานรายการของ",
              to: "เป็น",
              orNot: "หรือไม่",
              nonContacted: "ยังไม่ได้ติดต่อ",
              ipAddress: "IP Address",
            },
            exportModal: {
              title: "ออกรายงาน",
              cancel: "ยกเลิก",
              confirm: "ยืนยัน",
              header: "ตั้งชื่อรายงานความสนใจซื้อจำนวน",
              item: "รายการ",
              description: "รายงานที่ออกจะถูกกรองตามข้อมูลในหน้าตาราง",
              name: "ชื่อรายงาน",
              notificationSuccess: "ทำรายการสำเร็จ",
            },
          },
          notificationManagement: {
            index: {
              home: "หน้าแรก",
              title: "จัดการการแจ้งเตือน",
              header: "จัดการการแจ้งเตือน",
              type: "ประเภท",
              searchPlaceholder: "ค้นหาชื่อหัวข้อ / รายละเอียด",
              reset: "รีเซ็ต",
              filter: "กรอง",
              columns: {
                type: "ประเภท",
                header: "หัวข้อ",
                detail: "รายละเอียด",
                params: "params",
                notificationDate: "วันที่แจ้งเตือน",
                status: "สถานะ",
              },
              historyButton: "ประวัติการส่งแจ้งเตือน",
              addButton: "เพิ่มการแจ้งเตือน",
              typeOptions: {
                all: "ทั้งหมด",
                promotion: "โปรโมชัน",
                campaign: "แคมเปญ",
                notice: "แจ้งข่าวสาร",
                insurance: "ประกัน",
                paymentReminder: "เตือนชำระเบี้ย",
                paymentReminderRenewalSamePremium:
                  "เตือนชำระเบี้ยปีต่อเบี้ยเท่าเดิม",
                paymentReminderRenewalChangedPremium:
                  "เตือนชำระเบี้ยปีต่อเบี้ยเปลี่ยน",
                overduePaymentReminder: "ค้างชำระเบี้ย",
                overduePaymentReminderRenewalSamePremium:
                  "ค้างชำระเบี้ยปีต่อเบี้ยเท่าเดิม",
                overduePaymentReminderRenewalChangedPremium:
                  "ค้างชำระเบี้ยปีต่อเบี้ยเปลี่ยน",
                profileUpdateSuccess: "แก้ไขข้อมูลส่วนตัวสำเร็จ",
                profileUpdateFailure: "แก้ไขข้อมูลส่วนตัวไม่สำเร็จ",
                policyStatusUpdate: "ปรับสถานะกรมธรรม์",
                policyApproved: "กรมธรรม์ผ่าน",
                policyUnderReview: "พิจารณากรมธรรม์",
                requestPolicyCancellation: "ขอยกเลิกกรมธรรม์",
                policyCanceled: "ถูกยกเลิกกรมธรรม์",
                policyNotApproved: "ไม่อนุมัติกรมธรรม์",
                refundSuccessful: "คืนเงินสำเร็จ",
                cancellationSuccessful: "ยกเลิกสำเร็จ",
                autoDeduction: "ตัดเงินอัตโนมัติ",
              },
              statusOptions: {
                active: "ใช้งาน",
                inactive: "ไม่ใช้งาน",
              },
              tooltips: {
                noScheduledDate:
                  "รายการที่ระบบสร้างจะไม่แสดงวันที่แจ้งเตือน\n(แจ้งเตือนทันทีเมื่อเกิด Action ตามที่ระบบ\nกำหนดไว้)",
                activeStatus: "การแจ้งเตือนนี้กำลังใช้งานอยู่",
                inactiveStatus: "การแจ้งเตือนนี้ไม่ได้ใช้งาน",
                notificationDate:
                  "รายการที่ระบบสร้างจะไม่แสดงวันที่แจ้งเตือน (แจ้งเตือนทันทีเมื่อเกิด Action ตามที่ระบบกำหนดไว้)",
                status: "สถานะการใช้งานของแจ้งเตือน",
              },
              deleteNotification: "ลบการแจ้งเตือน",
              deleteNotificationInfo: "การแจ้งเตือน",
              cannotBeRestored: "จะถูกลบและไม่สามารถกู้คืนได้",
              cancel: "ยกเลิก",
              delete: "ลบ",
              deleteNotificationSuccess: "ลบการแจ้งเตือนสำเร็จ",
              duplicateNotification: "คัดลอกแจ้งเตือน",
              duplicateNotificationInfo: "ต้องการคัดลอกแจ้งเตือนหรือไม่",
              closeWindow: "ปิดหน้าต่างนี้",
              duplicate: "คัดลอก",
              duplicateNotificationSuccess: "คัดลอกการแจ้งเตือนสำเร็จ",
            },
            history: {
              home: "หน้าแรก",
              title2: "จัดการการแจ้งเตือน",
              title: "ประวัติการส่งแจ้งเตือน",
              header: "ประวัติการส่งแจ้งเตือน",
              back: "ย้อนกลับ",
              type: "ประเภท",
              channel: "ช่องทาง",
              startDate: "ตั้งแต่วันที่",
              endDate: "ถึงวันที่",
              dateRangeError: "ถึงวันที่ต้องไม่น้อยกว่าตั้งแต่วันที่",
              searchPlaceholder: "ค้นหาหัวข้อ / รายละเอียด / ผู้รับ",
              reset: "รีเซ็ต",
              filter: "กรอง",
              columns: {
                type: "ประเภท",
                header: "ชื่อหัวข้อ",
                detail: "รายละเอียด",
                receiver: "ผู้รับ",
                channel: "ช่องทาง",
                notificationDate: "วันที่แจ้งเตือน",
              },
              typeOptions: {
                all: "ทั้งหมด",
                promotion: "โปรโมชัน",
                campaign: "แคมเปญ",
                notice: "แจ้งข่าวสาร",
                paymentReminder: "เตือนชำระเบี้ย",
                paymentReminderRenewalSamePremium:
                  "เตือนชำระเบี้ยปีต่อเบี้ยเท่าเดิม",
                paymentReminderRenewalChangedPremium:
                  "เตือนชำระเบี้ยปีต่อเบี้ยเปลี่ยน",
                overduePaymentReminder: "ค้างชำระเบี้ย",
                overduePaymentReminderRenewalSamePremium:
                  "ค้างชำระเบี้ยปีต่อเบี้ยเท่าเดิม",
                overduePaymentReminderRenewalChangedPremium:
                  "ค้างชำระเบี้ยปีต่อเบี้ยเปลี่ยน",
                profileUpdateSuccess: "แก้ไขข้อมูลส่วนตัวสำเร็จ",
                profileUpdateFailure: "แก้ไขข้อมูลส่วนตัวไม่สำเร็จ",
                policyStatusUpdate: "ปรับสถานะกรมธรรม์",
                policyApproved: "กรมธรรม์ผ่าน",
                policyUnderReview: "พิจารณากรมธรรม์",
                requestPolicyCancellation: "ขอยกเลิกกรมธรรม์",
                policyCanceled: "ถูกยกเลิกกรมธรรม์",
                policyNotApproved: "ไม่อนุมัติกรมธรรม์",
                refundSuccessful: "คืนเงินสำเร็จ",
                cancellationSuccessful: "ยกเลิกสำเร็จ",
                autoDeduction: "ตัดเงินอัตโนมัติ",
              },
              channelOptions: {
                all: "ทั้งหมด",
                webNotification: "Front Store Notification",
                email: "Email",
                sms: "SMS",
              },
            },
            new: {
              home: "หน้าแรก",
              title2: "จัดการการแจ้งเตือน",
              title: "เพิ่มการแจ้งเตือน",
              detail: "รายละเอียด",
              notificationInformation: "ข้อมูลการแจ้งเตือน",
              type: "ประเภท",
              notificationDate: "วันที่แจ้งเตือน",
              action: "Action",
              actionType: "เมื่อกดที่ข้อความ",
              url: "URL",
              urlHelperText:
                "ใส่ URL หน้าที่ต้องการเช่น https://www.flexfreelance/account/profile เพื่อพาไปหน้าข้อมูลส่วนตัวในบัญชีของฉัน",
              selectActionOptions: {
                urlRedirect: "URL Redirect",
                openPopup: "เปิด Popup",
              },
              notificationChannels: "ช่องทางการแจ้งเตือน",
              notificationChannelsRequired: "กรุณาเลือกอย่างน้อย 1 ช่องทาง",
              webNotification: "Front Store Notification",
              webNotificationDescription:
                "ข้อความนี้จะแสดงทันทีผ่าน Front store เมื่อมีการเปิดใช้งาน web notification เอาไว้ และสามารถดูย้อนหลังได้ที่เมนู “การแจ้งเตือน” ของ Front store",
              email: "Email",
              emailDescription:
                "ข้อความนี้จะส่งไปที่ Mail box ของผู้ใช้แต่ละคนตามอีเมลที่ระบุไว้ในโปรไฟล์",
              sms: "SMS",
              smsDescription:
                "ข้อความนี้จะส่งไปที่กล่องข้อความในโทรศัพท์มือถือของผู้ใช้แต่ละคนตามเบอร์โทรศัพท์ที่ระบุไว้ในโปรไฟล์",
              subject: "ชื่อหัวข้อ",
              importantNotification: "แจ้งเตือนสำคัญ",
              importantNotificationTooltip:
                "ทำเครื่องหมายเพื่อให้การแจ้งเตือนนี้แสดงเป็นการแจ้งเตือนสำคัญใน Front store",
              detailsPlaceholder: "กรุณากรอกรายละเอียด",
              cancel: "ยกเลิก",
              create: "สร้าง",
              notificationSuccess: "สร้างการแจ้งเตือนสำเร็จ",
              typeOptions: {
                promotion: "โปรโมชัน",
                campaign: "แคมเปญ",
                notice: "แจ้งข่าวสาร",
                paymentReminder: "เตือนชำระเบี้ย",
                paymentReminderRenewalSamePremium:
                  "เตือนชำระเบี้ยปีต่อเบี้ยเท่าเดิม",
                paymentReminderRenewalChangedPremium:
                  "เตือนชำระเบี้ยปีต่อเบี้ยเปลี่ยน",
                overduePaymentReminder: "ค้างชำระเบี้ย",
                overduePaymentReminderRenewalSamePremium:
                  "ค้างชำระเบี้ยปีต่อเบี้ยเท่าเดิม",
                overduePaymentReminderRenewalChangedPremium:
                  "ค้างชำระเบี้ยปีต่อเบี้ยเปลี่ยน",
                profileUpdateSuccess: "แก้ไขข้อมูลส่วนตัวสำเร็จ",
                profileUpdateFailure: "แก้ไขข้อมูลส่วนตัวไม่สำเร็จ",
                policyStatusUpdate: "ปรับสถานะกรมธรรม์",
                policyApproved: "กรมธรรม์ผ่าน",
                policyUnderReview: "พิจารณากรมธรรม์",
                requestPolicyCancellation: "ขอยกเลิกกรมธรรม์",
                policyCanceled: "ถูกยกเลิกกรมธรรม์",
                policyNotApproved: "ไม่อนุมัติกรมธรรม์",
                refundSuccessful: "คืนเงินสำเร็จ",
                cancellationSuccessful: "ยกเลิกสำเร็จ",
                autoDeduction: "ตัดเงินอัตโนมัติ",
              },
              required: "ต้องไม่เว้นว่างเอาไว้",
            },
            edit: {
              home: "หน้าแรก",
              title2: "จัดการการแจ้งเตือน",
              title: "เพิ่มการแจ้งเตือน",
              detail: "รายละเอียด",
              isActive: "ใช้งาน",
              inactive: "ไม่ใช้งาน",
              notificationInformation: "ข้อมูลการแจ้งเตือน",
              type: "ประเภท",
              notificationDate: "วันที่แจ้งเตือน",
              action: "Action",
              actionType: "เมื่อกดที่ข้อความ",
              url: "URL",
              urlHelperText:
                "ใส่ URL หน้าที่ต้องการเช่น https://www.flexfreelance/account/profile เพื่อพาไปหน้าข้อมูลส่วนตัวในบัญชีของฉัน",
              selectActionOptions: {
                urlRedirect: "URL Redirect",
                openPopup: "เปิด Popup",
              },
              notificationChannels: "ช่องทางการแจ้งเตือน",
              notificationChannelsRequired: "กรุณาเลือกอย่างน้อย 1 ช่องทาง",
              webNotification: "Front Store Notification",
              webNotificationDescription:
                'ข้อความนี้จะแสดงทันทีผ่าน Front store เมื่อมีการเปิดใช้งาน web notification เอาไว้ และสามารถดูย้อนหลังได้ที่เมนู "การแจ้งเตือน" ของ Front store',
              email: "Email",
              emailDescription:
                "ข้อความนี้จะส่งไปที่ Mail box ของผู้ใช้แต่ละคนตามอีเมลที่ระบุไว้ในโปรไฟล์",
              sms: "SMS",
              smsDescription:
                "ข้อความนี้จะส่งไปที่กล่องข้อความในโทรศัพท์มือถือของผู้ใช้แต่ละคนตามเบอร์โทรศัพท์ที่ระบุไว้ในโปรไฟล์",
              subject: "ชื่อหัวข้อ",
              importantNotification: "แจ้งเตือนสำคัญ",
              importantNotificationTooltip:
                "ทำเครื่องหมายเพื่อให้การแจ้งเตือนนี้แสดงเป็นการแจ้งเตือนสำคัญใน Front store",
              detailsPlaceholder: "กรุณากรอกรายละเอียด",
              instructionDescription:
                "สามารถระบุตัวค่าตัวเลขจากระบบซึ่งแตกต่างกันตามผู้รับแต่ละคนลงในข้อความได้ ดังนี้",
              instructionOrderNumber: "หมายเลขกรมธรรม์ให้ใส่ค่าว่า ",
              orderNumber: " {{ORDER_NUMBER}} ",
              instructionExample: "เช่น กรมธรรม์หมายเลขคำขอที่ ",
              approved: "ผ่านการพิจารณาแล้ว",
              cancel: "ยกเลิก",
              update: "บันทึก",
              notificationSuccess: "สร้างการแจ้งเตือนสำเร็จ",
              typeOptions: {
                promotion: "โปรโมชัน",
                campaign: "แคมเปญ",
                notice: "แจ้งข่าวสาร",
                paymentReminder: "เตือนชำระเบี้ย",
                paymentReminderRenewalSamePremium:
                  "เตือนชำระเบี้ยปีต่อเบี้ยเท่าเดิม",
                paymentReminderRenewalChangedPremium:
                  "เตือนชำระเบี้ยปีต่อเบี้ยเปลี่ยน",
                overduePaymentReminder: "ค้างชำระเบี้ย",
                overduePaymentReminderRenewalSamePremium:
                  "ค้างชำระเบี้ยปีต่อเบี้ยเท่าเดิม",
                overduePaymentReminderRenewalChangedPremium:
                  "ค้างชำระเบี้ยปีต่อเบี้ยเปลี่ยน",
                profileUpdateSuccess: "แก้ไขข้อมูลส่วนตัวสำเร็จ",
                profileUpdateFailure: "แก้ไขข้อมูลส่วนตัวไม่สำเร็จ",
                policyStatusUpdate: "ปรับสถานะกรมธรรม์",
                policyApproved: "กรมธรรม์ผ่าน",
                policyUnderReview: "พิจารณากรมธรรม์",
                requestPolicyCancellation: "ขอยกเลิกกรมธรรม์",
                policyCanceled: "ถูกยกเลิกกรมธรรม์",
                policyNotApproved: "ไม่อนุมัติกรมธรรม์",
                refundSuccessful: "คืนเงินสำเร็จ",
                cancellationSuccessful: "ยกเลิกสำเร็จ",
                autoDeduction: "ตัดเงินอัตโนมัติ",
              },
              required: "ต้องไม่เว้นว่างเอาไว้",
            },
            components: {
              templateDescription: {
                dynamicVariableDescription:
                  "สามารถระบุตัวแปรจากระบบซึ่งแตกต่างกันตามผู้รับแต่ละคนลงในข้อความและ URL ได้ ดังนี้",
                [NotificationTemplateType.PAYMENT_REMINDER]: {
                  parameterDescription:
                    "การตั้งค่าด้านบนส่งผลกับการแจ้งเตือนโดย \n <hl>{{key}}</hl> จะทำให้ระบบส่งแจ้งเตือนก่อนครบกำหนดชำระเบี้ย X วัน",
                  policyId: "เลขกรมธรรม์ให้ใส่คำว่า <hl>{{key}}</hl>",
                  dueDate: "วันครบกำหนดให้ใส่คำว่า <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.PAYMENT_REMINDER_RENEWAL_SAME_PREMIUM]: {
                  parameterDescription:
                    "การตั้งค่าด้านบนส่งผลกับการแจ้งเตือนโดย \n <hl>{{key}}</hl> จะทำให้ระบบส่งแจ้งเตือนก่อนครบกำหนดชำระเบี้ย X วัน",
                  policyId: "เลขกรมธรรม์ให้ใส่คำว่า <hl>{{key}}</hl>",
                  dueDate: "วันครบกำหนดให้ใส่คำว่า <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.OVERDUE_PAYMENT_REMINDER]: {
                  parameterDescription:
                    "การตั้งค่าด้านบนส่งผลกับการแจ้งเตือนโดย \n <hl>{{key}}</hl> จะทำให้ระบบส่งแจ้งเตือนหลังจากค้างชำระ X วัน",
                  policyId: "เลขกรมธรรม์ให้ใส่คำว่า <hl>{{key}}</hl>",
                  dueDate: "วันครบกำหนดให้ใส่คำว่า <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.OVERDUE_PAYMENT_REMINDER_RENEWAL_SAME_PREMIUM]: {
                  parameterDescription:
                    "การตั้งค่าด้านบนส่งผลกับการแจ้งเตือนโดย \n <hl>{{key}}</hl> จะทำให้ระบบส่งแจ้งเตือนหลังจากค้างชำระ X วัน",
                  policyId: "เลขกรมธรรม์ให้ใส่คำว่า <hl>{{key}}</hl>",
                  dueDate: "วันครบกำหนดให้ใส่คำว่า <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.PAYMENT_REMINDER_RENEWAL_CHANGED_PREMIUM]: {
                  parameterDescription:
                    "การตั้งค่าด้านบนส่งผลกับการแจ้งเตือนโดย \n <hl>{{key}}</hl> จะทำให้ระบบส่งแจ้งเตือนก่อนครบกำหนดชำระเบี้ย X วัน",
                  policyId: "เลขกรมธรรม์ให้ใส่คำว่า <hl>{{key}}</hl>",
                  dueDate: "วันครบกำหนดให้ใส่คำว่า <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.OVERDUE_PAYMENT_REMINDER_RENEWAL_CHANGED_PREMIUM]: {
                  parameterDescription:
                    "การตั้งค่าด้านบนส่งผลกับการแจ้งเตือนโดย \n <hl>{{key}}</hl> จะทำให้ระบบส่งแจ้งเตือนหลังจากค้างชำระ X วัน",
                  policyId: "เลขกรมธรรม์ให้ใส่คำว่า <hl>{{key}}</hl>",
                  dueDate: "วันครบกำหนดให้ใส่คำว่า <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.PROFILE_UPDATE_SUCCESS]: {
                  changeData:
                    "ประเภทข้อมูลที่แก้ไขให้ใส่คำว่า <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.PROFILE_UPDATE_FAILURE]: {
                  changeData:
                    "ประเภทข้อมูลที่แก้ไขให้ใส่คำว่า <hl>{{key}}</hl>",
                  reason: "เหตุผลที่ไม่สำเร็จให้ใส่คำว่า <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.POLICY_APPROVED]: {
                  requestID: "เลขใบคำขอ <hl>{{key}}</hl>",
                  insuranceCompany: "บริษัทประกัน <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.POLICY_UNDER_REVIEW]: {
                  requestID: "เลขใบคำขอ <hl>{{key}}</hl>",
                  insuranceCompany: "บริษัทประกัน <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.REQUEST_POLICY_CANCELLATION]: {
                  requestID: "เลขใบคำขอ <hl>{{key}}</hl>",
                  insuranceCompany: "บริษัทประกัน <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.POLICY_CANCELED]: {
                  requestID: "เลขใบคำขอ <hl>{{key}}</hl>",
                  insuranceCompany: "บริษัทประกัน <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.POLICY_NOT_APPROVED]: {
                  requestID: "เลขใบคำขอ <hl>{{key}}</hl>",
                  insuranceCompany: "บริษัทประกัน <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.REFUND_SUCCESSFUL]: {
                  requestID: "เลขใบคำขอ <hl>{{key}}</hl>",
                  insuranceCompany: "บริษัทประกัน <hl>{{key}}</hl>",
                },
                [NotificationTemplateType.CANCELLATION_SUCCESSFUL]: {
                  requestID: "เลขใบคำขอ <hl>{{key}}</hl>",
                  insuranceCompany: "บริษัทประกัน <hl>{{key}}</hl>",
                },
              },
            },
          },
          nameChangeRequest: {
            index: {
              home: "หน้าแรก",
              title: "คำขอเปลี่ยนชื่อ",
              header: "คำขอเปลี่ยนชื่อ",
              searchPlaceholder: "ชื่อ-นามสกุล, อีเมล",
              reset: "รีเซ็ต",
              filter: "กรอง",
              columns: {
                fullName: "ชื่อ-นามสกุล (ใหม่)",
                email: "อีเมล",
                createdAt: "วันที่ขอเปลี่ยนชื่อ",
                updatedAt: "วันที่อนุมัติ",
                status: "สถานะ",
              },
              status: {
                [NameChangeRequestStatus.NEW]: "รออนุมัติ",
                [NameChangeRequestStatus.SUCCESS]: "อนุมัติ",
                [NameChangeRequestStatus.APPROVED]: "อนุมัติ",
                [NameChangeRequestStatus.REJECTED]: "ไม่อนุมัติ",
                [NameChangeRequestStatus.FAILED]: "ไม่อนุมัติ",
              },
              approveModal: {
                title: "อนุมัติ",
                confirmText:
                  "ต้องการเปลี่ยนชื่อจาก <b>{{oldName}}</b> เป็น <b>{{newName}}</b> หรือไม่",
              },
              rejectModal: {
                title: "ไม่อนุมัติ",
                confirmText:
                  "ระบุเหตุผลที่ไม่อนุมัติเปลี่ยนชื่อจาก <b>{{oldName}}</b> เป็น <b>{{newName}}</b>",
                reasonLabel: "เหตุผล",
                reasonOptions: {
                  unreadableOrExpiredId: "รูปถ่ายเอกสารไม่ชัดเจน / บัตรหมดอายุ",
                  mismatchedNameOnId: "ชื่อไม่ตรงกับเอกสารบัตรประชาชน",
                  noNameChangeDocument: "ขาดเอกสารใบเปลี่ยนชื่อ / ทะเบียนสมรส",
                  missingSignatureOrWrongDocType: "พิมพ์ผิด / มีลายเซ็นผิด",
                  other: "อื่น ๆ (ต้องกรอกสาเหตุเพิ่มเติม)",
                },
                reasonOtherLabel: "เหตุผลเพิ่มเติม",
              },
              documentModal: {
                title: "หลักฐานการเปลี่ยนชื่อ",
                page: "{{current}} จาก {{total}}",
                noAttachment: "ไม่พบไฟล์แนบ",
                loadingPdf: "กำลังโหลด...",
                pdfLoadError:
                  "ไม่สามารถโหลด PDF นี้ได้ ลองใหม่อีกครั้งหรือเปิดไฟล์ในแท็บใหม่",
                pdfPageTitle: "{{name}}",
                attachmentGroup: {
                  nameChangeDocument: "หนังสือสำคัญแสดงการเปลี่ยนชื่อตัว",
                  idCardCopy: "สำเนาบัตรประชาชน",
                },
              },
              cancel: "ยกเลิก",
              close: "ปิดหน้าต่างนี้",
              approve: "อนุมัติ",
              approveDisabledTooltip:
                "ต้องเปิดไปถึงเอกสารหน้าสุดท้ายถึงจะสามารถอนุมัติได้",
              reject: "ไม่อนุมัติ",
              approveSuccess: "อนุมัติการเปลี่ยนชื่อเรียบร้อย",
              rejectSuccess: "ไม่อนุมัติการเปลี่ยนชื่อเรียบร้อย",
              alreadyProcessedTitle: "แก้ไขไม่สำเร็จ",
              alreadyProcessedMessage:
                "เนื่องจากมีผู้ใช้งานท่านอื่นแก้ไขและบันทึกข้อมูลนี้ไปก่อนหน้าแล้ว\n กรุณารีเฟรชหน้าจอเพื่อตรวจสอบข้อมูลล่าสุดก่อนดำเนินการอีกครั้ง",
              alreadyProcessedOk: "ตกลง",
            },
          },
          user: {
            index: {
              title: "ข้อมูลลูกค้า",
              home: "หน้าแรก",
              reset: "รีเซ็ต",
              filter: "กรอง",
              keyword: "ค้นหาชื่อ นามสกุล / อีเมล / เบอร์โทร",
              name: "ชื่อ นามสกุล",
              email: "อีเมล",
              phoneNumber: "เบอร์โทร",
              noOfPolicies: "จำนวนกรมธรรม์",
              createdAt: "วันที่สมัคร",
              viewTransaction: "ดูกรมธรรม์",
              viewPayment: "ดูการชำระเงิน",
            },
            detail: {
              userInfo: "ข้อมูลลูกค้า",
              home: "หน้าแรก",
              name: "ชื่อลูกค้า",
              email: "อีเมล",
              phoneNumber: "เบอร์โทร",
              noOfPolicies: "จำนวนกรมธรรม์",
              providerType: "วิธีการสมัคร",
              createdAt: "วันที่สมัคร",
              back: "ย้อนกลับ",
              viewTransaction: "ดูกรมธรรม์",
              viewPayment: "ดูการชำระเงิน",
              image: "รูป",
            },
          },
          riderConfig: {
            title: "การตั้งค่าสัญญาเพิ่มเติม",
            home: "หน้าแรก",
            header: "ความสัมพันธ์ของสัญญาเพิ่มเติม",
            description1:
              "ใช้สำหรับตั้งค่า Web Application ในหน้า“ซื้อประกันกับเรา”",
            description2:
              "โดยใส่ข้อมูลว่าประกันแต่ละประเภทมีความสัมพันธ์เป็นสัญญาเพิ่มเติมกันอย่างไร เช่น ถ้าใส่ว่าประกัน IPD เป็นสัญญาเพิ่มเติมของประกันอุบัติเหตุ",
            description3:
              "เมื่อผู้ใช้เลือกความคุ้มครอง IPD ระบบจะเลือกประกันอุบัติเหตุให้อัตโนมัติ",
            notification:
              "การแก้ไขข้อมูลส่วนนี้ไม่ส่งผลย้อนหลังต่อแบบประกันที่สร้างสำเร็จไปแล้ว",
            example: "ตัวอย่างหน้า “ซื้อประกันกับเรา”",
            additionalContract: "สัญญาเพิ่มเติม",
            notificationSuccess: "ทำรายการสำเร็จ",
            close: "ปิดหน้าต่างนี้",
            delete: "ลบข้อมูล",
            deleteTitle: "ลบสัญญาเพิ่มเติม",
            deleteItem1: "ข้อมูลสัญญาเพิ่มเติม",
            deleteItem2: "ของ",
            deleteItem3: "จะถูกลบและไม่สามารถกู้คืนได้",
            noData: "ไม่มีข้อมูลสัญญาเพิ่มเติม",
            ManageRiderConfigModal: {
              title: "เลือกสัญญาเพิ่มเติมของ {{name}}",
              description:
                "ถ้าใส่ว่าประกัน IPD เป็นสัญญาเพิ่มเติมของประกันอุบัติเหตุ เมื่อผู้ใช้เลือกความคุ้มครอง IPD ระบบจะเลือกประกันอุบัติเหตุให้อัตโนมัติ",
              insuranceType: "ประเภทประกัน",
              cancel: "ยกเลิก",
              select: "เลือก",
              notificationSuccess: "ทำรายการสำเร็จ",
              errorTitle: "เกิดข้อผิดพลาด",
              close: "ปิดหน้าต่างนี้",
              loopDetected1: "ข้อมูลสัญญาเพิ่มเติมของ",
              loopDetected2: "ไม่ถูกต้องกรุณาตรวจสอบอีกครั้ง",
              errorDescription:
                "เกิดจากความสัมพันธ์ของประกันหลักและสัญญาเพิ่มเติมไม่สอดคล้องกัน กรุณาตรวจสอบข้อมูลสัญญาเพิ่มเติมให้ถูกต้องอีกครั้ง",
            },
          },
          broker: {
            index: {
              title: "เพิ่ม/ลด Broker",
              home: "หน้าแรก",
              add: "เพิ่ม Broker",
              name: "ชื่อ Broker",
              status: "สถานะ",
              columnStatus: {
                all: "ทั้งหมด",
                active: "ใช้งาน",
                inactive: "ไม่ใช้งาน",
              },
              refId: "Ref ID",
              remark: "หมายเหตุ",
              updatedAt: "วันที่แก้ไขล่าสุด",
              reset: "รีเซ็ต",
              filter: "กรอง",
              deleteBroker: "ลบ Broker",
              brokerInfo: "ข้อมูล Broker",
              cannotBeRestored: "จะถูกลบและไม่สามารถกู้คืนได้",
              close: "ปิดหน้าต่างนี้",
              delete: "ลบข้อมูล",
              notificationSuccess: "ทำรายการสำเร็จ",
            },
            new: {
              title: "เพิ่ม Broker",
              home: "หน้าแรก",
              rootPath: "จัดการ Broker",
              header: "ข้อมูล Broker",
              active: "ใช้งาน",
              name: "ชื่อ Broker",
              refId: "Ref ID",
              remark: "หมายเหตุ",
              cancel: "ยกเลิก",
              create: "สร้าง",
              notificationSuccess: "ทำรายการสำเร็จ",
            },
            edit: {
              home: "หน้าแรก",
              rootPath: "จัดการ Broker",
              header: "ข้อมูล Broker",
              active: "ใช้งาน",
              name: "ชื่อ Broker",
              refId: "Ref ID",
              remark: "หมายเหตุ",
              cancel: "ยกเลิก",
              save: "บันทึก",
              notificationSuccess: "ทำรายการสำเร็จ",
            },
          },
          order: {
            index: {
              home: "หน้าแรก",
              title: "คำสั่งซื้อ",
              export: "ออกรายงาน",
              form: {
                keyword: "เลขที่ใบคำขอ, ชื่อเจ้าของกรมธรรม์",
                insuranceCompany: "บริษัทประกัน",
                type: "ประเภท",
                status: "สถานะคำสั่งซื้อ",
                paymentStatus: "สถานะการชำระเงิน",
              },
              reset: "รีเซ็ต",
              filter: "กรอง",
              all: "ทั้งหมด",
              table: {
                applicationNumber: "เลขที่ใบคำขอ",
                insured: "ชื่อผู้เอาประกัน",
                company: "บริษัท",
                type: "ประเภท",
                amount: "ยอดชำระ",
                status: "สถานะคำสั่งซื้อ",
                paymentStatus: "สถานะการชำระเงิน",
                updatedAt: "วันเวลาที่แก้ไขล่าสุด",
              },
              orderStatus: {
                all: "ทั้งหมด",
                [EnumOrderStatus.PENDING_REVIEW]: "รอพิจารณา",
                REVIEWED: "พิจารณาแล้ว",
                [EnumOrderStatus.DRAFT]: "ไม่สำเร็จ",
                [EnumOrderStatus.APPROVED]: "พิจารณาแล้ว",
                [EnumOrderStatus.REJECTED]: "พิจารณาแล้ว",
                failedTooltip:
                  'รายการที่เกิดจากการเลือกแผนประกัน (ยังทำรายการไม่สำเร็จ) จะไม่แสดงข้อมูลการชำระเงินและแก้ไขสถานะไม่ได้ โดยระบบจะเปลี่ยนเป็น "รอพิจารณา" อัตโนมัติเมื่อทำรายการสำเร็จ',
              },
              paymentStatus: {
                all: "ทั้งหมด",
                [EnumPaymentStatus.PENDING_PAYMENT]: "รอชำระเงิน",
                [EnumPaymentStatus.SUCCESS]: "สำเร็จ",
                [EnumPaymentStatus.CANCELLED]: "ยกเลิก",
              },
              EditStatusModal: {
                title: "ปรับสถานะคำสั่งซื้อ",
                state: "สถานะคำสั่งซื้อ",
                of: "ของ",
                affectedTitle:
                  "การปรับสถานะคำสั่งซื้อ จะส่งผลกระทบต่อกรมธรรม์ที่เชื่อมโยงอยู่ดังต่อไปนี้:",
                status: {
                  WAITING: "รอพิจารณา",
                  APPROVED: "อนุมัติ",
                  REJECTED: "ไม่อนุมัติ",
                  FAILED: "ไม่สำเร็จ",
                },
                cancel: "ยกเลิก",
                confirm: "ยืนยัน",
                success: "ทำรายการสำเร็จ",
              },
              notificationSuccess: "ทำรายการสำเร็จ",
              Male: "ชาย",
              Female: "หญิง",
              relationValue: {
                father: "บิดา",
                mother: "มารดา",
                child: "บุตร",
                spouse: "คู่สมรส",
                life_partner: "คู่ชีวิต",
              },
            },
            detail: {
              home: "หน้าแรก",
              root: "คำสั่งซื้อ",
              orderInfo: "ข้อมูลคำสั่งซื้อ",
              policyInfo: "ข้อมูลกรมธรรม์",
              policyDescription: "แบบประกันทั้งหมดที่อยู่ในแพ็กเกจ",
              kycResult: "ผลการ KYC",
              back: "ย้อนกลับ",
              applicationNumber: "เลขที่ใบคำขอ",
              insured: "ชื่อผู้เอาประกัน",
              company: "บริษัท",
              type: "ประเภท",
              package: "ชื่อแพ็กเกจ",
              netPayment: "ยอดชำระสุทธิ",
              orderStatus: "สถานะคำสั่งซื้อ",
              paymentStatus: "สถานะการชำระเงิน",
              createdAt: "วันที่สร้าง",
              updatedAt: "วันที่แก้ไขล่าสุด",
              viewDetail: "ดูรายละเอียด",
              baht: "{{amount}} บาท",
              customPackage: "แพ็คเกจปรับแต่งเอง",
              failedTooltip:
                'รายการที่เกิดจากการเลือกแผนประกัน (ยังทำรายการไม่สำเร็จ) จะไม่แสดงข้อมูลการชำระเงินและแก้ไขสถานะไม่ได้ โดยระบบจะเปลี่ยนเป็น "รอพิจารณา" อัตโนมัติเมื่อทำรายการสำเร็จ',
              kycStatus: {
                passed: "ผ่าน",
                pending: "รอดำเนินการ",
              },
              PolicyDetailModal: {
                title: "รายละเอียดคำสั่งซื้อ",
                viewPolicyDetail: "ดูรายละเอียดกรมธรรม์",
                close: "ปิดหน้าต่างนี้",
                healthQuestion: "คำถามสุขภาพ",
                policyholder: "ผู้เอาประกัน",
                benefitMoney: "เงินผลประโยชน์",
                beneficiaries: "ผู้รับผลประโยชน์",
                fullname: "ชื่อ-นามสกุล",
                relation: "ความสัมพันธ์",
                percent: "เปอร์เซ็นผลประโยชน์",
                benefitMoneyQuestion:
                  "ถ้ามีเงินผลประโยชน์ตามกรมธรรม์ประกันภัยเป็นเงินปันผล/เงินคืนตามกรมธรรม์ประกันภัย",
                accountName: "ชื่อเจ้าของบัญชี",
                bankAccount: "เลขที่บัญชีธนาคาร",
                bank: "ธนาคาร",
                branch: "ชื่อสาขา",
                gender: "เพศ",
                policyHolderQuestion:
                  "คุณประสงค์ที่จะใช้สิทธิ ขอยกเว้นเงินภาษีเงินได้หรือไม่",
                fullnameEn: "ชื่อ-นามสกุล (EN)",
                birthDate: "วันเดือนปี (ค.ศ.) เกิด",
                age: "อายุ",
                nationality: "สัญชาติ",
                status: "สถานภาพ",
                email: "อีเมล",
                phoneNumber: "เบอร์โทรศัพท์",
                occupation: "อาชีพ",
                workplaceName: "ชื่อสถานที่ทำงาน",
                annualIncome: "รายได้ต่อปี (บาท)",
                currentAddress: "ที่อยู่ปัจจุบัน",
                registeredAddress: "ที่อยู่ตามทะเบียนบ้าน",
                workAddress: "ที่อยู่ที่ทำงาน",
                excepTaxYes: "ประสงค์",
                excepTaxNo: "ไม่ประสงค์",
                ageUnit: "ปี",
                relationValue: {
                  father: "บิดา",
                  mother: "มารดา",
                  child: "บุตร",
                  spouse: "คู่สมรส",
                  life_partner: "คู่ชีวิต",
                },
              },
              KycResultModal: {
                title: "รายละเอียดคำสั่งซื้อ",
                close: "ปิดหน้าต่างนี้",
                question: "คำถาม",
                nationalIdNumber: "เลขบัตรประชาชน",
                backIdCardCode: "รหัสหลังบัตรประชาชน",
              },
              status: {
                [EnumOrderStatus.PENDING_REVIEW]: "รอพิจารณา",
                [EnumOrderStatus.APPROVED]: "พิจารณาแล้ว",
                [EnumOrderStatus.REJECTED]: "พิจารณาแล้ว",
                [EnumOrderStatus.DRAFT]: "ไม่สำเร็จ",
              },
              paymentStatusText: {
                [EnumPaymentStatus.PENDING_PAYMENT]: "รอชำระเงิน",
                [EnumPaymentStatus.SUCCESS]: "สำเร็จ",
                [EnumPaymentStatus.CANCELLED]: "ยกเลิก",
              },
            },
          },
        },
        auth: {
          ResetPassword: {
            forgotPassword: "ลืมรหัสผ่าน",
            inputEmail: "กรอกอีเมลเพื่อสร้างรหัสผ่านในการเข้าสู่ระบบใหม่",
            send: "ส่ง",
            link1:
              "ลิงก์สำหรับสร้างรหัสผ่านใหม่ได้ถูกส่งไปที่อีเมล \n{{email}}\n",
            link2:
              "เรียบร้อยแล้ว \n กรุณาคลิกลิงก์จากอีเมลเพื่อสร้างรหัสผ่านในการเข้าสู่ระบบ",
          },
        },
      },
      components: {
        common: {
          languagesDropdown: {
            label: "ภาษา",
            lang: "ไทย",
          },
          PopMenu: {
            logout: "ออกจากระบบ",
            logoutInfo1: "คุณต้องการออกจากระบบใช่หรือไม่ หากต้องการกรุณากดปุ่ม",
            logoutInfo2: "ด้านล่างเพื่อทำการออกจากระบบ",
            confirmLogout: "ยืนยัน",
            cancel: "ยกเลิก",
            profile: "โปรไฟล์",
            avatar: "AD",
          },
          JsonEditorReact: {
            modalTitle: "ชนิดข้อมูลไม่ถูกต้อง",
            modalDescription: "กรุณาตรวจสอบชนิดข้อมูลของพารามิเตอร์:",
            okButtonLabel: "ตกลง",
            or: "หรือ",
            validationError:
              '"{{key}}" ต้องเป็น {{expectedTypes}} แต่ได้รับ {{actualType}}',
            typeNames: {
              string: "ข้อความ",
              number: "ตัวเลข (มีทศนิยม)",
              integer: "เลขจำนวนเต็ม",
              boolean: "ค่าบูลีน",
              array: "อาร์เรย์",
              object: "ออบเจ็กต์",
            },
            rangeErrorTitle: "ค่าไม่อยู่ในช่วงที่กำหนด",
            rangeErrorMin: '"{{key}}" ต้องมีค่าไม่น้อยกว่า {{min}}',
            rangeErrorMax: '"{{key}}" ต้องมีค่าไม่เกิน {{max}}',
            keyMismatchError:
              "ไม่สามารถเปลี่ยนชื่อพารามิเตอร์ได้ ชื่อที่กำหนดไว้คือ {{keys}}",
          },
          MaterialIcon: {
            notFoundIcon: "ไม่พบไอคอน",
          },
          UploadAvatar: {
            avatar: "AD",
          },
          InfoCard: {
            viewDetail: "ดูรายละเอียด",
            baht: "{{amount}} บาท",
            broker: "Broker:",
          },
        },
        advance: {
          AddressList: {
            total: "ทั้งหมด {{amount}}",
            addressNo: "ที่อยู่ {{index}}",
          },
          FileUploadList: {
            total: "ทั้งหมด {{amount}}",
          },
          SingleFileUpload: {
            uploadFile: "อัพโหลดไฟล์",
            invalidFileExtension: "รองรับเฉพาะไฟล์ {{extensions}} เท่านั้น",
          },
          Editor: {
            enterText: "กรอกข้อความที่นี่...",
          },
          JsonForms: {
            noData: "ไม่มีข้อมูล",
            noSelection: "ยังไม่ได้เลือกรายการ",
          },
        },
        SideBar: {
          appName: "My Benefit",
        },
        Table: {
          noData: "ไม่พบข้อมูลที่ค้นหา กรุณาตรวจสอบค่าในตัวกรองอีกครั้ง",
          noDataOnFilter:
            "ไม่พบข้อมูลที่ค้นหา กรุณาตรวจสอบค่าในตัวกรองอีกครั้ง",
          noInsuranceData: "ไม่มีข้อมูลแบบประกัน",
        },
        FilterTableWithQueryParams: {
          confirm: "กรอง",
          reset: "รีเซ็ต",
        },
      },
      routes: {
        menu: {
          customerService: "บริการลูกค้า",
          appScreenDisplay: "การแสดงผลหน้า App",
          notification: "การแจ้งเตือน",
          adminManagement: "จัดการ Admin",
          adminMenu: "เพิ่ม/ลด Admin",
          roleMenu: "กำหนดสิทธิ",
          systemAndData: "จัดการระบบและข้อมูล",
          insuranceMenu: "จัดการชุดแบบประกัน",
          settingMenu: "การตั้งค่า",
          menu: "เมนู",
          insurance: "จัด Package และจัด Weight",
          enrollment: "เปิด/ปิด ประกันและ Package",
          report: "ออกรายงาน",
          marketplaceReport: "ออกรายงาน Marketplace",
          insuranceCompany: "เพิ่ม/ลด บริษัทประกัน",
          occupation: "เพิ่ม/ลด อาชีพ",
          dynamicConfig: "ข้อมูลส่วนขายประกัน",
          workspace: "เพิ่ม/ลด Workspace",
          insurancePlan: "เพิ่ม/ลด ข้อมูลแบบประกัน",
          paymentTransaction: "การชำระเงิน",
          insuranceTransaction: "สถานะกรมธรรม์",
          overdueTransaction: "รายการค้างชำระ",
          lead: "Log ค้นหาประกัน",
          notificationManagement: "จัดการการแจ้งเตือน",
          user: "ข้อมูลลูกค้า",
          riderConfig: "การตั้งค่าสัญญาเพิ่มเติม",
          frontStoreManagement: "จัดการ Front store",
          broker: "เพิ่ม/ลด Broker",
          nameChangeRequest: "คำขอเปลี่ยนชื่อ",
          productManagement: "จัดการประกัน",
          order: "คำสั่งซื้อ",
        },
        Routes: {
          expireTimeAlertTitle: "หมดเวลาการใช้งาน",
          expireTimeAlertChildren:
            "กรุณาเข้าสู่ระบบอีกครั้ง เนื่องจากไม่ได้มีการใช้งานระบบเป็นระยะเวลา {{timeout}} นาที",
          expireTimeAlertOkButtonLabel: "เข้าสู่ระบบอีกครั้ง",
        },
      },
      yup: {
        error: {
          required: "ต้องไม่เว้นว่างเอาไว้",
          requiredTh: "ต้องไม่เว้นว่างเอาไว้ (TH)",
          requiredEn: "ต้องไม่เว้นว่างเอาไว้ (EN)",
          invalidEmailSyntax: "รูปแบบอีเมลไม่ถูกต้อง",
          typeNumber: "ต้องเป็นตัวเลข",
          GtZero: "ต้องเป็นตัวเลขมากกว่า 0",
          GteZero: "ต้องเป็นตัวเลขมากกว่าหรือเท่ากับ 0",
          GteOne: "ต้องเป็นตัวเลขมากกว่าหรือเท่ากับ 1",
          insuranceNameThDuplicate: "ชื่อแบบประกัน (TH) ซ้ำกับที่มีในระบบ",
          insuranceNameEnDuplicate: "ชื่อแบบประกัน (EN) ซ้ำกับที่มีในระบบ",
          packageNameThDuplicate: "ชื่อแพ็กเกจ (TH) ซ้ำกับที่มีในระบบ",
          packageNameEnDuplicate: "ชื่อแพ็กเกจ (EN) ซ้ำกับที่มีในระบบ",
          invalidEmailFormat: "รูปแบบอีเมลไม่ถูกต้อง",
          invalidPhoneNumberFormat: "รูปแบบเบอร์โทรไม่ถูกต้อง",
          nameDuplicate: "ต้องไม่ซ้ำกับที่มีในระบบ",
          scheduledAtPast: "ไม่สามารถเลือกวันเวลาที่ผ่านมาแล้วได้",
          maxDate: "วันที่เริ่มต้นต้องไม่เกินวันที่สิ้นสุด ",
          minDate: "วันที่สิ้นสุดต้องไม่ต่ำกว่าวันที่เริ่มต้น ",
          maxLength200: "ต้องไม่เกิน 200 ตัวอักษร",
        },
      },
      error: {
        notCurrentVersion:
          "ไม่สามารถบันทึกการแก้ไข Version นี้ได้เนื่องจาก\nระหว่างที่แก้ไขมีผู้ซื้อประกันสำเร็จไปแล้ว กรุณากดกลับไปหน้าตาราง\nจากนั้นกดแก้ไขใหม่อีกครั้ง ระบบจะสร้าง Version ใหม่ให้อัตโนมัติ",
        required: "ต้องไม่เว้นว่างเอาไว้",
        saveError: "แบบประกันนี้ถูกเผยแพร่แล้ว",
        accept: "ตกลง",
        saveErrorChildren:
          "การลงทะเบียนนี้ถูกเผยแพร่ไปแล้ว กรุณากดปุ่ม (ตกลง) เพื่อ refresh และลองใหม่อีกครั้ง",
        notEmptyAtLeastOne: "กรุณาเลือกอย่างน้อย 1 ประเภทประกัน",
        duplicate: "ต้องไม่ซ้ำกับที่มีอยู่",
        phoneNumberInvalid: "รูปแบบเบอร์โทรศัพท์ไม่ถูกต้อง",
        enRequired: "ภาษาอังกฤษต้องไม่เว้นว่างเอาไว้",
        thRequired: "ภาษาไทยต้องไม่เว้นว่างเอาไว้",
        close: "ปิดหน้าต่างนี้",
        masterInsurancePlanPublishedValidationFailed: {
          detail: "รายละเอียดแบบประกัน",
          customPackage: "ข้อมูลสำหรับ Custom package เอง",
          premiums: "ตารางกรมธรรม์",
          conditions: "การตั้งค่าเงื่อนไข",
          result: "ผลการตรวจสอบ",
          notReadyToPublish: "เวอร์ชัน {{versionName}} ยังไม่พร้อมเผยแพร่",
          errorMessages:
            "เนื่องจากยังกรอกข้อมูลบางส่วนไม่ครบถ้วน โปรดตรวจสอบข้อมูลดังต่อไปนี้",
          close: "ปิดหน้าต่างนี้",
        },
        dependencyLoopDetected: {
          errorTitle: "เกิดข้อผิดพลาด",
          close: "ปิดหน้าต่างนี้",
          loopDetected1: "ข้อมูลเกณฑ์การขายของ",
          loopDetected2: "ไม่ถูกต้องกรุณาตรวจสอบอีกครั้ง",
          errorDescription:
            "เกิดจากความสัมพันธ์ของประกันหลักและสัญญาเพิ่มเติมไม่สอดคล้องกัน กรุณาตรวจสอบข้อมูลให้ถูกต้องอีกครั้ง",
        },
      },
      modal: {
        delete: {
          title: "ยืนยันการลบ",
          confirm: "ลบข้อมูล",
          close: "ปิดหน้าต่างนี้",
        },
        close: "ปิด",
      },
      validateMasterInsurancePlanDependenciesErrorModal: {
        saveUnsuccess: "บันทึกข้อมูลไม่สำเร็จ",
        invalidDependentContent:
          "เนื่องจากไม่มีประกันหลักของประกันตามรายชื่อต่อไปนี้",
        accept: "ตกลง",
        rider: "สัญญาเพิ่มเติม",
        dependent: "ประกันหลักที่ต้องใส่เพิ่มอย่างน้อย 1 รายการ",
      },
    },
  },
};

export default th;
